
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexq71mWYqdlqZmopi37Vl_45HudNcSY5A9by16_bGtbcW5sMeta } from "/data/root-data/TG/lip-sync/master/lip-sync/src/pages/index.vue?macro=true";
import { default as referOJZPVCTJ8Xb4Fa1XOvZLE2Ib6axTbEPSkRdepD9ci84Meta } from "/data/root-data/TG/lip-sync/master/lip-sync/src/pages/refer.vue?macro=true";
import { default as termsRTKxKHAEEKa5rvO_5etsBe7p_xERxwm2_45ZHlJYz4CRAMeta } from "/data/root-data/TG/lip-sync/master/lip-sync/src/pages/terms.vue?macro=true";
import { default as account2mg9jY1Z6_45poOL9CcMxQW1tkHRoTc1SydNljCQr_45GWgMeta } from "/data/root-data/TG/lip-sync/master/lip-sync/src/pages/account.vue?macro=true";
import { default as pricingbfR_bZ2OHnUOZgayjeZmg5rjz2h6uXzERdWUBxDrZ5EMeta } from "/data/root-data/TG/lip-sync/master/lip-sync/src/pages/pricing.vue?macro=true";
import { default as ai_45dubbingdSnC0cZXy2lub7fsq0rNhOHPpFHQGpgAeNDbgtd568AMeta } from "/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-dubbing.vue?macro=true";
import { default as indexPOOf6xh835hs_DewunsqwWVCAQulikFYYbQ6DyzG_45LMMeta } from "/data/root-data/TG/lip-sync/master/lip-sync/src/pages/blog/index.vue?macro=true";
import { default as _91slug_93aukse00KNwXDngtseFvGxwLEPzd6ltgJpn63vWCIpj0Meta } from "/data/root-data/TG/lip-sync/master/lip-sync/src/pages/blog/[slug].vue?macro=true";
import { default as baby_45singingjoJ3adYbNT_456nUSDKcVaBiIJNgXkmJtFKFY6zKnct0wMeta } from "/data/root-data/TG/lip-sync/master/lip-sync/src/pages/baby-singing.vue?macro=true";
import { default as baby_45talkingEHYq9KDQYBBIn5odRSaQ4hdxUohycp_c5LPxXltABQgMeta } from "/data/root-data/TG/lip-sync/master/lip-sync/src/pages/baby-talking.vue?macro=true";
import { default as my_45creations_45kd_7rSduKUp245_45wHwnq_45hgjq0VU_45Zf0tFb0SvTuRAMeta } from "/data/root-data/TG/lip-sync/master/lip-sync/src/pages/my-creations.vue?macro=true";
import { default as audio_45cleanerzXS8JMblLu6W1j_tLrdvLanW4IOtB00_455TEPM86IXRYMeta } from "/data/root-data/TG/lip-sync/master/lip-sync/src/pages/audio-cleaner.vue?macro=true";
import { default as voice_45cloningh9UHT5pb3_IyyRP3g0UpSFVIVQBXMnC_45FMUDGoJDtucMeta } from "/data/root-data/TG/lip-sync/master/lip-sync/src/pages/voice-cloning.vue?macro=true";
import { default as ai_45news_45anchorkiOOVwypoDdLGcFhB_Liox3q2M3Uh_45qawXWOaJ9YrrIMeta } from "/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-news-anchor.vue?macro=true";
import { default as audio_45enhancert7nUNRo4UmaqYmlpA19IKrCmfmxSCWp59L_M1F2Hjb0Meta } from "/data/root-data/TG/lip-sync/master/lip-sync/src/pages/audio-enhancer.vue?macro=true";
import { default as privacy_45policyXSpcM6iJsMNvcAxvlcB6tAsWktQXUftehnc22jfBB50Meta } from "/data/root-data/TG/lip-sync/master/lip-sync/src/pages/privacy-policy.vue?macro=true";
import { default as product_45avatarFLt0beE3xM5wiqfQ94cbIDIczWcXqnjb9sBjBFQP75YMeta } from "/data/root-data/TG/lip-sync/master/lip-sync/src/pages/product-avatar.vue?macro=true";
import { default as talking_45avatar_45n95qXJsFMz4UvllwoWBxhzIDnogWnr058Dad1_45FXyUMeta } from "/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-avatar.vue?macro=true";
import { default as ai_45baby_45podcast0nW2NZ6Y9u3jzvV1CMcg5WNYwP_bdjHg_45gsnEjU1wQQMeta } from "/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-baby-podcast.vue?macro=true";
import { default as avatar_45dialogue2MP9G4w7D5hGYvAYh5MVhGKBsunZ23fyQSDreglAs7QMeta } from "/data/root-data/TG/lip-sync/master/lip-sync/src/pages/avatar-dialogue.vue?macro=true";
import { default as cartoon_45singingsStunrhg27FU1GN_ukir6c0LdAfxXp6E0Tr9ZwFja_45YMeta } from "/data/root-data/TG/lip-sync/master/lip-sync/src/pages/cartoon-singing.vue?macro=true";
import { default as history_45lipsync3ExyrBeUh6zCH9GyU5BCmTcbDhN_45f_xD7VAgC39zCxgMeta } from "/data/root-data/TG/lip-sync/master/lip-sync/src/pages/history-lipsync.vue?macro=true";
import { default as talking_45animalsOef9AwboIL2Y_45P5Q6Sr6OmBosI5y5nuEYy44F_B8wUsMeta } from "/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-animals.vue?macro=true";
import { default as talking_45cartoonkySIHcW9Czs1vYtgSLayUK9zSCst20Umuu9qRey8YNoMeta } from "/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-cartoon.vue?macro=true";
import { default as ai_45singing_45photordn8ugc69fF_V0HXjfOV2WW6KbYcIwE09QRhCYEyPR0Meta } from "/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-singing-photo.vue?macro=true";
import { default as talking_45photo_45aiTn8dVHeUp9562xVWwm7BY8IcmU7_eicSOny3WIQ4ulMMeta } from "/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-photo-ai.vue?macro=true";
import { default as ai_45image_45to_45videoynP4rycFYp54ttTsNvx7SvLvHf_fUL5LJs1daMZ_454NMMeta } from "/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-image-to-video.vue?macro=true";
import { default as ai_45human_45generatorrIRFFMgIBomJH0G55h7h3J0znh9pQd9EZoJPDf53Z9IMeta } from "/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-human-generator.vue?macro=true";
import { default as ai_45image_45generatornSxcSdLld2uVC_4538mQup_t1y92ilxXJ2oFN_45Pug92e4Meta } from "/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-image-generator.vue?macro=true";
import { default as ai_45avatar_45generator_45qZNCqTmJXIA9lquYZKPf6cz_45NZ63S6_xFhKlxAgqJYMeta } from "/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-avatar-generator.vue?macro=true";
import { default as ai_45influencer_45generatoruX4k2qJ5RBBUi3qTqZq040hwnJwN9Fj0zFQKUPYs7B0Meta } from "/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-influencer-generator.vue?macro=true";
import { default as ai_45animate_45face_45lip_45syncGB9_45_xo1q3ReJfK_LZSY7EcSotC2hHgCClL4McnlmkIMeta } from "/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-animate-face-lip-sync.vue?macro=true";
import { default as component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta } from "/data/root-data/TG/lip-sync/master/lip-sync/node_modules/.pnpm/nuxt@3.21.5_@parcel+watcher@2.5.6_@types+node@22.19.19_@vue+compiler-sfc@3.5.34_better-_e3fd2a4e19b437fbd207cf7b4f73ca20/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI } from "/data/root-data/TG/lip-sync/master/lip-sync/node_modules/.pnpm/nuxt@3.21.5_@parcel+watcher@2.5.6_@types+node@22.19.19_@vue+compiler-sfc@3.5.34_better-_e3fd2a4e19b437fbd207cf7b4f73ca20/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index___en",
    path: "/",
    meta: indexq71mWYqdlqZmopi37Vl_45HudNcSY5A9by16_bGtbcW5sMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/index.vue")
  },
  {
    name: "index___ru",
    path: "/ru",
    meta: indexq71mWYqdlqZmopi37Vl_45HudNcSY5A9by16_bGtbcW5sMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/index.vue")
  },
  {
    name: "index___ja",
    path: "/ja",
    meta: indexq71mWYqdlqZmopi37Vl_45HudNcSY5A9by16_bGtbcW5sMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/index.vue")
  },
  {
    name: "index___id",
    path: "/id",
    meta: indexq71mWYqdlqZmopi37Vl_45HudNcSY5A9by16_bGtbcW5sMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/index.vue")
  },
  {
    name: "index___ar",
    path: "/ar",
    meta: indexq71mWYqdlqZmopi37Vl_45HudNcSY5A9by16_bGtbcW5sMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/index.vue")
  },
  {
    name: "index___cn",
    path: "/cn",
    meta: indexq71mWYqdlqZmopi37Vl_45HudNcSY5A9by16_bGtbcW5sMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    meta: indexq71mWYqdlqZmopi37Vl_45HudNcSY5A9by16_bGtbcW5sMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    meta: indexq71mWYqdlqZmopi37Vl_45HudNcSY5A9by16_bGtbcW5sMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    meta: indexq71mWYqdlqZmopi37Vl_45HudNcSY5A9by16_bGtbcW5sMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/index.vue")
  },
  {
    name: "index___it",
    path: "/it",
    meta: indexq71mWYqdlqZmopi37Vl_45HudNcSY5A9by16_bGtbcW5sMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/index.vue")
  },
  {
    name: "index___kr",
    path: "/kr",
    meta: indexq71mWYqdlqZmopi37Vl_45HudNcSY5A9by16_bGtbcW5sMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/index.vue")
  },
  {
    name: "index___nl",
    path: "/nl",
    meta: indexq71mWYqdlqZmopi37Vl_45HudNcSY5A9by16_bGtbcW5sMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/index.vue")
  },
  {
    name: "index___pt",
    path: "/pt",
    meta: indexq71mWYqdlqZmopi37Vl_45HudNcSY5A9by16_bGtbcW5sMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/index.vue")
  },
  {
    name: "index___tr",
    path: "/tr",
    meta: indexq71mWYqdlqZmopi37Vl_45HudNcSY5A9by16_bGtbcW5sMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/index.vue")
  },
  {
    name: "index___zh",
    path: "/zh",
    meta: indexq71mWYqdlqZmopi37Vl_45HudNcSY5A9by16_bGtbcW5sMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/index.vue")
  },
  {
    name: "refer___en",
    path: "/refer",
    meta: { ...(referOJZPVCTJ8Xb4Fa1XOvZLE2Ib6axTbEPSkRdepD9ci84Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/refer.vue")
  },
  {
    name: "refer___ru",
    path: "/ru/refer",
    meta: { ...(referOJZPVCTJ8Xb4Fa1XOvZLE2Ib6axTbEPSkRdepD9ci84Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/refer.vue")
  },
  {
    name: "refer___ja",
    path: "/ja/refer",
    meta: { ...(referOJZPVCTJ8Xb4Fa1XOvZLE2Ib6axTbEPSkRdepD9ci84Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/refer.vue")
  },
  {
    name: "refer___id",
    path: "/id/refer",
    meta: { ...(referOJZPVCTJ8Xb4Fa1XOvZLE2Ib6axTbEPSkRdepD9ci84Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/refer.vue")
  },
  {
    name: "refer___ar",
    path: "/ar/refer",
    meta: { ...(referOJZPVCTJ8Xb4Fa1XOvZLE2Ib6axTbEPSkRdepD9ci84Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/refer.vue")
  },
  {
    name: "refer___cn",
    path: "/cn/refer",
    meta: { ...(referOJZPVCTJ8Xb4Fa1XOvZLE2Ib6axTbEPSkRdepD9ci84Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/refer.vue")
  },
  {
    name: "refer___de",
    path: "/de/refer",
    meta: { ...(referOJZPVCTJ8Xb4Fa1XOvZLE2Ib6axTbEPSkRdepD9ci84Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/refer.vue")
  },
  {
    name: "refer___es",
    path: "/es/refer",
    meta: { ...(referOJZPVCTJ8Xb4Fa1XOvZLE2Ib6axTbEPSkRdepD9ci84Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/refer.vue")
  },
  {
    name: "refer___fr",
    path: "/fr/refer",
    meta: { ...(referOJZPVCTJ8Xb4Fa1XOvZLE2Ib6axTbEPSkRdepD9ci84Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/refer.vue")
  },
  {
    name: "refer___it",
    path: "/it/refer",
    meta: { ...(referOJZPVCTJ8Xb4Fa1XOvZLE2Ib6axTbEPSkRdepD9ci84Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/refer.vue")
  },
  {
    name: "refer___kr",
    path: "/kr/refer",
    meta: { ...(referOJZPVCTJ8Xb4Fa1XOvZLE2Ib6axTbEPSkRdepD9ci84Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/refer.vue")
  },
  {
    name: "refer___nl",
    path: "/nl/refer",
    meta: { ...(referOJZPVCTJ8Xb4Fa1XOvZLE2Ib6axTbEPSkRdepD9ci84Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/refer.vue")
  },
  {
    name: "refer___pt",
    path: "/pt/refer",
    meta: { ...(referOJZPVCTJ8Xb4Fa1XOvZLE2Ib6axTbEPSkRdepD9ci84Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/refer.vue")
  },
  {
    name: "refer___tr",
    path: "/tr/refer",
    meta: { ...(referOJZPVCTJ8Xb4Fa1XOvZLE2Ib6axTbEPSkRdepD9ci84Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/refer.vue")
  },
  {
    name: "refer___zh",
    path: "/zh/refer",
    meta: { ...(referOJZPVCTJ8Xb4Fa1XOvZLE2Ib6axTbEPSkRdepD9ci84Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/refer.vue")
  },
  {
    name: "terms___en",
    path: "/terms",
    meta: { ...(termsRTKxKHAEEKa5rvO_5etsBe7p_xERxwm2_45ZHlJYz4CRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/terms.vue")
  },
  {
    name: "terms___ru",
    path: "/ru/terms",
    meta: { ...(termsRTKxKHAEEKa5rvO_5etsBe7p_xERxwm2_45ZHlJYz4CRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/terms.vue")
  },
  {
    name: "terms___ja",
    path: "/ja/terms",
    meta: { ...(termsRTKxKHAEEKa5rvO_5etsBe7p_xERxwm2_45ZHlJYz4CRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/terms.vue")
  },
  {
    name: "terms___id",
    path: "/id/terms",
    meta: { ...(termsRTKxKHAEEKa5rvO_5etsBe7p_xERxwm2_45ZHlJYz4CRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/terms.vue")
  },
  {
    name: "terms___ar",
    path: "/ar/terms",
    meta: { ...(termsRTKxKHAEEKa5rvO_5etsBe7p_xERxwm2_45ZHlJYz4CRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/terms.vue")
  },
  {
    name: "terms___cn",
    path: "/cn/terms",
    meta: { ...(termsRTKxKHAEEKa5rvO_5etsBe7p_xERxwm2_45ZHlJYz4CRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/terms.vue")
  },
  {
    name: "terms___de",
    path: "/de/terms",
    meta: { ...(termsRTKxKHAEEKa5rvO_5etsBe7p_xERxwm2_45ZHlJYz4CRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/terms.vue")
  },
  {
    name: "terms___es",
    path: "/es/terms",
    meta: { ...(termsRTKxKHAEEKa5rvO_5etsBe7p_xERxwm2_45ZHlJYz4CRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/terms.vue")
  },
  {
    name: "terms___fr",
    path: "/fr/terms",
    meta: { ...(termsRTKxKHAEEKa5rvO_5etsBe7p_xERxwm2_45ZHlJYz4CRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/terms.vue")
  },
  {
    name: "terms___it",
    path: "/it/terms",
    meta: { ...(termsRTKxKHAEEKa5rvO_5etsBe7p_xERxwm2_45ZHlJYz4CRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/terms.vue")
  },
  {
    name: "terms___kr",
    path: "/kr/terms",
    meta: { ...(termsRTKxKHAEEKa5rvO_5etsBe7p_xERxwm2_45ZHlJYz4CRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/terms.vue")
  },
  {
    name: "terms___nl",
    path: "/nl/terms",
    meta: { ...(termsRTKxKHAEEKa5rvO_5etsBe7p_xERxwm2_45ZHlJYz4CRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/terms.vue")
  },
  {
    name: "terms___pt",
    path: "/pt/terms",
    meta: { ...(termsRTKxKHAEEKa5rvO_5etsBe7p_xERxwm2_45ZHlJYz4CRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/terms.vue")
  },
  {
    name: "terms___tr",
    path: "/tr/terms",
    meta: { ...(termsRTKxKHAEEKa5rvO_5etsBe7p_xERxwm2_45ZHlJYz4CRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/terms.vue")
  },
  {
    name: "terms___zh",
    path: "/zh/terms",
    meta: { ...(termsRTKxKHAEEKa5rvO_5etsBe7p_xERxwm2_45ZHlJYz4CRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/terms.vue")
  },
  {
    name: "account___en",
    path: "/account",
    meta: { ...(account2mg9jY1Z6_45poOL9CcMxQW1tkHRoTc1SydNljCQr_45GWgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/account.vue")
  },
  {
    name: "account___ru",
    path: "/ru/account",
    meta: { ...(account2mg9jY1Z6_45poOL9CcMxQW1tkHRoTc1SydNljCQr_45GWgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/account.vue")
  },
  {
    name: "account___ja",
    path: "/ja/account",
    meta: { ...(account2mg9jY1Z6_45poOL9CcMxQW1tkHRoTc1SydNljCQr_45GWgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/account.vue")
  },
  {
    name: "account___id",
    path: "/id/account",
    meta: { ...(account2mg9jY1Z6_45poOL9CcMxQW1tkHRoTc1SydNljCQr_45GWgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/account.vue")
  },
  {
    name: "account___ar",
    path: "/ar/account",
    meta: { ...(account2mg9jY1Z6_45poOL9CcMxQW1tkHRoTc1SydNljCQr_45GWgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/account.vue")
  },
  {
    name: "account___cn",
    path: "/cn/account",
    meta: { ...(account2mg9jY1Z6_45poOL9CcMxQW1tkHRoTc1SydNljCQr_45GWgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/account.vue")
  },
  {
    name: "account___de",
    path: "/de/account",
    meta: { ...(account2mg9jY1Z6_45poOL9CcMxQW1tkHRoTc1SydNljCQr_45GWgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/account.vue")
  },
  {
    name: "account___es",
    path: "/es/account",
    meta: { ...(account2mg9jY1Z6_45poOL9CcMxQW1tkHRoTc1SydNljCQr_45GWgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/account.vue")
  },
  {
    name: "account___fr",
    path: "/fr/account",
    meta: { ...(account2mg9jY1Z6_45poOL9CcMxQW1tkHRoTc1SydNljCQr_45GWgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/account.vue")
  },
  {
    name: "account___it",
    path: "/it/account",
    meta: { ...(account2mg9jY1Z6_45poOL9CcMxQW1tkHRoTc1SydNljCQr_45GWgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/account.vue")
  },
  {
    name: "account___kr",
    path: "/kr/account",
    meta: { ...(account2mg9jY1Z6_45poOL9CcMxQW1tkHRoTc1SydNljCQr_45GWgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/account.vue")
  },
  {
    name: "account___nl",
    path: "/nl/account",
    meta: { ...(account2mg9jY1Z6_45poOL9CcMxQW1tkHRoTc1SydNljCQr_45GWgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/account.vue")
  },
  {
    name: "account___pt",
    path: "/pt/account",
    meta: { ...(account2mg9jY1Z6_45poOL9CcMxQW1tkHRoTc1SydNljCQr_45GWgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/account.vue")
  },
  {
    name: "account___tr",
    path: "/tr/account",
    meta: { ...(account2mg9jY1Z6_45poOL9CcMxQW1tkHRoTc1SydNljCQr_45GWgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/account.vue")
  },
  {
    name: "account___zh",
    path: "/zh/account",
    meta: { ...(account2mg9jY1Z6_45poOL9CcMxQW1tkHRoTc1SydNljCQr_45GWgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/account.vue")
  },
  {
    name: "pricing___en",
    path: "/pricing",
    meta: pricingbfR_bZ2OHnUOZgayjeZmg5rjz2h6uXzERdWUBxDrZ5EMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/pricing.vue")
  },
  {
    name: "pricing___ru",
    path: "/ru/pricing",
    meta: pricingbfR_bZ2OHnUOZgayjeZmg5rjz2h6uXzERdWUBxDrZ5EMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/pricing.vue")
  },
  {
    name: "pricing___ja",
    path: "/ja/pricing",
    meta: pricingbfR_bZ2OHnUOZgayjeZmg5rjz2h6uXzERdWUBxDrZ5EMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/pricing.vue")
  },
  {
    name: "pricing___id",
    path: "/id/pricing",
    meta: pricingbfR_bZ2OHnUOZgayjeZmg5rjz2h6uXzERdWUBxDrZ5EMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/pricing.vue")
  },
  {
    name: "pricing___ar",
    path: "/ar/pricing",
    meta: pricingbfR_bZ2OHnUOZgayjeZmg5rjz2h6uXzERdWUBxDrZ5EMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/pricing.vue")
  },
  {
    name: "pricing___cn",
    path: "/cn/pricing",
    meta: pricingbfR_bZ2OHnUOZgayjeZmg5rjz2h6uXzERdWUBxDrZ5EMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/pricing.vue")
  },
  {
    name: "pricing___de",
    path: "/de/pricing",
    meta: pricingbfR_bZ2OHnUOZgayjeZmg5rjz2h6uXzERdWUBxDrZ5EMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/pricing.vue")
  },
  {
    name: "pricing___es",
    path: "/es/pricing",
    meta: pricingbfR_bZ2OHnUOZgayjeZmg5rjz2h6uXzERdWUBxDrZ5EMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/pricing.vue")
  },
  {
    name: "pricing___fr",
    path: "/fr/pricing",
    meta: pricingbfR_bZ2OHnUOZgayjeZmg5rjz2h6uXzERdWUBxDrZ5EMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/pricing.vue")
  },
  {
    name: "pricing___it",
    path: "/it/pricing",
    meta: pricingbfR_bZ2OHnUOZgayjeZmg5rjz2h6uXzERdWUBxDrZ5EMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/pricing.vue")
  },
  {
    name: "pricing___kr",
    path: "/kr/pricing",
    meta: pricingbfR_bZ2OHnUOZgayjeZmg5rjz2h6uXzERdWUBxDrZ5EMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/pricing.vue")
  },
  {
    name: "pricing___nl",
    path: "/nl/pricing",
    meta: pricingbfR_bZ2OHnUOZgayjeZmg5rjz2h6uXzERdWUBxDrZ5EMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/pricing.vue")
  },
  {
    name: "pricing___pt",
    path: "/pt/pricing",
    meta: pricingbfR_bZ2OHnUOZgayjeZmg5rjz2h6uXzERdWUBxDrZ5EMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/pricing.vue")
  },
  {
    name: "pricing___tr",
    path: "/tr/pricing",
    meta: pricingbfR_bZ2OHnUOZgayjeZmg5rjz2h6uXzERdWUBxDrZ5EMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/pricing.vue")
  },
  {
    name: "pricing___zh",
    path: "/zh/pricing",
    meta: pricingbfR_bZ2OHnUOZgayjeZmg5rjz2h6uXzERdWUBxDrZ5EMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/pricing.vue")
  },
  {
    name: "ai-dubbing___en",
    path: "/ai-dubbing",
    meta: ai_45dubbingdSnC0cZXy2lub7fsq0rNhOHPpFHQGpgAeNDbgtd568AMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-dubbing.vue")
  },
  {
    name: "ai-dubbing___ru",
    path: "/ru/ai-dubbing",
    meta: ai_45dubbingdSnC0cZXy2lub7fsq0rNhOHPpFHQGpgAeNDbgtd568AMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-dubbing.vue")
  },
  {
    name: "ai-dubbing___ja",
    path: "/ja/ai-dubbing",
    meta: ai_45dubbingdSnC0cZXy2lub7fsq0rNhOHPpFHQGpgAeNDbgtd568AMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-dubbing.vue")
  },
  {
    name: "ai-dubbing___id",
    path: "/id/ai-dubbing",
    meta: ai_45dubbingdSnC0cZXy2lub7fsq0rNhOHPpFHQGpgAeNDbgtd568AMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-dubbing.vue")
  },
  {
    name: "ai-dubbing___ar",
    path: "/ar/ai-dubbing",
    meta: ai_45dubbingdSnC0cZXy2lub7fsq0rNhOHPpFHQGpgAeNDbgtd568AMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-dubbing.vue")
  },
  {
    name: "ai-dubbing___cn",
    path: "/cn/ai-dubbing",
    meta: ai_45dubbingdSnC0cZXy2lub7fsq0rNhOHPpFHQGpgAeNDbgtd568AMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-dubbing.vue")
  },
  {
    name: "ai-dubbing___de",
    path: "/de/ai-dubbing",
    meta: ai_45dubbingdSnC0cZXy2lub7fsq0rNhOHPpFHQGpgAeNDbgtd568AMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-dubbing.vue")
  },
  {
    name: "ai-dubbing___es",
    path: "/es/ai-dubbing",
    meta: ai_45dubbingdSnC0cZXy2lub7fsq0rNhOHPpFHQGpgAeNDbgtd568AMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-dubbing.vue")
  },
  {
    name: "ai-dubbing___fr",
    path: "/fr/ai-dubbing",
    meta: ai_45dubbingdSnC0cZXy2lub7fsq0rNhOHPpFHQGpgAeNDbgtd568AMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-dubbing.vue")
  },
  {
    name: "ai-dubbing___it",
    path: "/it/ai-dubbing",
    meta: ai_45dubbingdSnC0cZXy2lub7fsq0rNhOHPpFHQGpgAeNDbgtd568AMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-dubbing.vue")
  },
  {
    name: "ai-dubbing___kr",
    path: "/kr/ai-dubbing",
    meta: ai_45dubbingdSnC0cZXy2lub7fsq0rNhOHPpFHQGpgAeNDbgtd568AMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-dubbing.vue")
  },
  {
    name: "ai-dubbing___nl",
    path: "/nl/ai-dubbing",
    meta: ai_45dubbingdSnC0cZXy2lub7fsq0rNhOHPpFHQGpgAeNDbgtd568AMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-dubbing.vue")
  },
  {
    name: "ai-dubbing___pt",
    path: "/pt/ai-dubbing",
    meta: ai_45dubbingdSnC0cZXy2lub7fsq0rNhOHPpFHQGpgAeNDbgtd568AMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-dubbing.vue")
  },
  {
    name: "ai-dubbing___tr",
    path: "/tr/ai-dubbing",
    meta: ai_45dubbingdSnC0cZXy2lub7fsq0rNhOHPpFHQGpgAeNDbgtd568AMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-dubbing.vue")
  },
  {
    name: "ai-dubbing___zh",
    path: "/zh/ai-dubbing",
    meta: ai_45dubbingdSnC0cZXy2lub7fsq0rNhOHPpFHQGpgAeNDbgtd568AMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-dubbing.vue")
  },
  {
    name: "blog___en",
    path: "/blog",
    meta: indexPOOf6xh835hs_DewunsqwWVCAQulikFYYbQ6DyzG_45LMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/blog/index.vue")
  },
  {
    name: "blog___ru",
    path: "/ru/blog",
    meta: indexPOOf6xh835hs_DewunsqwWVCAQulikFYYbQ6DyzG_45LMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/blog/index.vue")
  },
  {
    name: "blog___ja",
    path: "/ja/blog",
    meta: indexPOOf6xh835hs_DewunsqwWVCAQulikFYYbQ6DyzG_45LMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/blog/index.vue")
  },
  {
    name: "blog___id",
    path: "/id/blog",
    meta: indexPOOf6xh835hs_DewunsqwWVCAQulikFYYbQ6DyzG_45LMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/blog/index.vue")
  },
  {
    name: "blog___ar",
    path: "/ar/blog",
    meta: indexPOOf6xh835hs_DewunsqwWVCAQulikFYYbQ6DyzG_45LMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/blog/index.vue")
  },
  {
    name: "blog___cn",
    path: "/cn/blog",
    meta: indexPOOf6xh835hs_DewunsqwWVCAQulikFYYbQ6DyzG_45LMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/blog/index.vue")
  },
  {
    name: "blog___de",
    path: "/de/blog",
    meta: indexPOOf6xh835hs_DewunsqwWVCAQulikFYYbQ6DyzG_45LMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/blog/index.vue")
  },
  {
    name: "blog___es",
    path: "/es/blog",
    meta: indexPOOf6xh835hs_DewunsqwWVCAQulikFYYbQ6DyzG_45LMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/blog/index.vue")
  },
  {
    name: "blog___fr",
    path: "/fr/blog",
    meta: indexPOOf6xh835hs_DewunsqwWVCAQulikFYYbQ6DyzG_45LMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/blog/index.vue")
  },
  {
    name: "blog___it",
    path: "/it/blog",
    meta: indexPOOf6xh835hs_DewunsqwWVCAQulikFYYbQ6DyzG_45LMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/blog/index.vue")
  },
  {
    name: "blog___kr",
    path: "/kr/blog",
    meta: indexPOOf6xh835hs_DewunsqwWVCAQulikFYYbQ6DyzG_45LMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/blog/index.vue")
  },
  {
    name: "blog___nl",
    path: "/nl/blog",
    meta: indexPOOf6xh835hs_DewunsqwWVCAQulikFYYbQ6DyzG_45LMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/blog/index.vue")
  },
  {
    name: "blog___pt",
    path: "/pt/blog",
    meta: indexPOOf6xh835hs_DewunsqwWVCAQulikFYYbQ6DyzG_45LMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/blog/index.vue")
  },
  {
    name: "blog___tr",
    path: "/tr/blog",
    meta: indexPOOf6xh835hs_DewunsqwWVCAQulikFYYbQ6DyzG_45LMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/blog/index.vue")
  },
  {
    name: "blog___zh",
    path: "/zh/blog",
    meta: indexPOOf6xh835hs_DewunsqwWVCAQulikFYYbQ6DyzG_45LMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/blog/index.vue")
  },
  {
    name: "blog-slug___en",
    path: "/blog/:slug()",
    meta: _91slug_93aukse00KNwXDngtseFvGxwLEPzd6ltgJpn63vWCIpj0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/blog/[slug].vue")
  },
  {
    name: "blog-slug___ru",
    path: "/ru/blog/:slug()",
    meta: _91slug_93aukse00KNwXDngtseFvGxwLEPzd6ltgJpn63vWCIpj0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/blog/[slug].vue")
  },
  {
    name: "blog-slug___ja",
    path: "/ja/blog/:slug()",
    meta: _91slug_93aukse00KNwXDngtseFvGxwLEPzd6ltgJpn63vWCIpj0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/blog/[slug].vue")
  },
  {
    name: "blog-slug___id",
    path: "/id/blog/:slug()",
    meta: _91slug_93aukse00KNwXDngtseFvGxwLEPzd6ltgJpn63vWCIpj0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/blog/[slug].vue")
  },
  {
    name: "blog-slug___ar",
    path: "/ar/blog/:slug()",
    meta: _91slug_93aukse00KNwXDngtseFvGxwLEPzd6ltgJpn63vWCIpj0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/blog/[slug].vue")
  },
  {
    name: "blog-slug___cn",
    path: "/cn/blog/:slug()",
    meta: _91slug_93aukse00KNwXDngtseFvGxwLEPzd6ltgJpn63vWCIpj0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/blog/[slug].vue")
  },
  {
    name: "blog-slug___de",
    path: "/de/blog/:slug()",
    meta: _91slug_93aukse00KNwXDngtseFvGxwLEPzd6ltgJpn63vWCIpj0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/blog/[slug].vue")
  },
  {
    name: "blog-slug___es",
    path: "/es/blog/:slug()",
    meta: _91slug_93aukse00KNwXDngtseFvGxwLEPzd6ltgJpn63vWCIpj0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/blog/[slug].vue")
  },
  {
    name: "blog-slug___fr",
    path: "/fr/blog/:slug()",
    meta: _91slug_93aukse00KNwXDngtseFvGxwLEPzd6ltgJpn63vWCIpj0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/blog/[slug].vue")
  },
  {
    name: "blog-slug___it",
    path: "/it/blog/:slug()",
    meta: _91slug_93aukse00KNwXDngtseFvGxwLEPzd6ltgJpn63vWCIpj0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/blog/[slug].vue")
  },
  {
    name: "blog-slug___kr",
    path: "/kr/blog/:slug()",
    meta: _91slug_93aukse00KNwXDngtseFvGxwLEPzd6ltgJpn63vWCIpj0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/blog/[slug].vue")
  },
  {
    name: "blog-slug___nl",
    path: "/nl/blog/:slug()",
    meta: _91slug_93aukse00KNwXDngtseFvGxwLEPzd6ltgJpn63vWCIpj0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/blog/[slug].vue")
  },
  {
    name: "blog-slug___pt",
    path: "/pt/blog/:slug()",
    meta: _91slug_93aukse00KNwXDngtseFvGxwLEPzd6ltgJpn63vWCIpj0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/blog/[slug].vue")
  },
  {
    name: "blog-slug___tr",
    path: "/tr/blog/:slug()",
    meta: _91slug_93aukse00KNwXDngtseFvGxwLEPzd6ltgJpn63vWCIpj0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/blog/[slug].vue")
  },
  {
    name: "blog-slug___zh",
    path: "/zh/blog/:slug()",
    meta: _91slug_93aukse00KNwXDngtseFvGxwLEPzd6ltgJpn63vWCIpj0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/blog/[slug].vue")
  },
  {
    name: "baby-singing___en",
    path: "/baby-singing",
    meta: baby_45singingjoJ3adYbNT_456nUSDKcVaBiIJNgXkmJtFKFY6zKnct0wMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/baby-singing.vue")
  },
  {
    name: "baby-singing___ru",
    path: "/ru/baby-singing",
    meta: baby_45singingjoJ3adYbNT_456nUSDKcVaBiIJNgXkmJtFKFY6zKnct0wMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/baby-singing.vue")
  },
  {
    name: "baby-singing___ja",
    path: "/ja/baby-singing",
    meta: baby_45singingjoJ3adYbNT_456nUSDKcVaBiIJNgXkmJtFKFY6zKnct0wMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/baby-singing.vue")
  },
  {
    name: "baby-singing___id",
    path: "/id/baby-singing",
    meta: baby_45singingjoJ3adYbNT_456nUSDKcVaBiIJNgXkmJtFKFY6zKnct0wMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/baby-singing.vue")
  },
  {
    name: "baby-singing___ar",
    path: "/ar/baby-singing",
    meta: baby_45singingjoJ3adYbNT_456nUSDKcVaBiIJNgXkmJtFKFY6zKnct0wMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/baby-singing.vue")
  },
  {
    name: "baby-singing___cn",
    path: "/cn/baby-singing",
    meta: baby_45singingjoJ3adYbNT_456nUSDKcVaBiIJNgXkmJtFKFY6zKnct0wMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/baby-singing.vue")
  },
  {
    name: "baby-singing___de",
    path: "/de/baby-singing",
    meta: baby_45singingjoJ3adYbNT_456nUSDKcVaBiIJNgXkmJtFKFY6zKnct0wMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/baby-singing.vue")
  },
  {
    name: "baby-singing___es",
    path: "/es/baby-singing",
    meta: baby_45singingjoJ3adYbNT_456nUSDKcVaBiIJNgXkmJtFKFY6zKnct0wMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/baby-singing.vue")
  },
  {
    name: "baby-singing___fr",
    path: "/fr/baby-singing",
    meta: baby_45singingjoJ3adYbNT_456nUSDKcVaBiIJNgXkmJtFKFY6zKnct0wMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/baby-singing.vue")
  },
  {
    name: "baby-singing___it",
    path: "/it/baby-singing",
    meta: baby_45singingjoJ3adYbNT_456nUSDKcVaBiIJNgXkmJtFKFY6zKnct0wMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/baby-singing.vue")
  },
  {
    name: "baby-singing___kr",
    path: "/kr/baby-singing",
    meta: baby_45singingjoJ3adYbNT_456nUSDKcVaBiIJNgXkmJtFKFY6zKnct0wMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/baby-singing.vue")
  },
  {
    name: "baby-singing___nl",
    path: "/nl/baby-singing",
    meta: baby_45singingjoJ3adYbNT_456nUSDKcVaBiIJNgXkmJtFKFY6zKnct0wMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/baby-singing.vue")
  },
  {
    name: "baby-singing___pt",
    path: "/pt/baby-singing",
    meta: baby_45singingjoJ3adYbNT_456nUSDKcVaBiIJNgXkmJtFKFY6zKnct0wMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/baby-singing.vue")
  },
  {
    name: "baby-singing___tr",
    path: "/tr/baby-singing",
    meta: baby_45singingjoJ3adYbNT_456nUSDKcVaBiIJNgXkmJtFKFY6zKnct0wMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/baby-singing.vue")
  },
  {
    name: "baby-singing___zh",
    path: "/zh/baby-singing",
    meta: baby_45singingjoJ3adYbNT_456nUSDKcVaBiIJNgXkmJtFKFY6zKnct0wMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/baby-singing.vue")
  },
  {
    name: "baby-talking___en",
    path: "/baby-talking",
    meta: baby_45talkingEHYq9KDQYBBIn5odRSaQ4hdxUohycp_c5LPxXltABQgMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/baby-talking.vue")
  },
  {
    name: "baby-talking___ru",
    path: "/ru/baby-talking",
    meta: baby_45talkingEHYq9KDQYBBIn5odRSaQ4hdxUohycp_c5LPxXltABQgMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/baby-talking.vue")
  },
  {
    name: "baby-talking___ja",
    path: "/ja/baby-talking",
    meta: baby_45talkingEHYq9KDQYBBIn5odRSaQ4hdxUohycp_c5LPxXltABQgMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/baby-talking.vue")
  },
  {
    name: "baby-talking___id",
    path: "/id/baby-talking",
    meta: baby_45talkingEHYq9KDQYBBIn5odRSaQ4hdxUohycp_c5LPxXltABQgMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/baby-talking.vue")
  },
  {
    name: "baby-talking___ar",
    path: "/ar/baby-talking",
    meta: baby_45talkingEHYq9KDQYBBIn5odRSaQ4hdxUohycp_c5LPxXltABQgMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/baby-talking.vue")
  },
  {
    name: "baby-talking___cn",
    path: "/cn/baby-talking",
    meta: baby_45talkingEHYq9KDQYBBIn5odRSaQ4hdxUohycp_c5LPxXltABQgMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/baby-talking.vue")
  },
  {
    name: "baby-talking___de",
    path: "/de/baby-talking",
    meta: baby_45talkingEHYq9KDQYBBIn5odRSaQ4hdxUohycp_c5LPxXltABQgMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/baby-talking.vue")
  },
  {
    name: "baby-talking___es",
    path: "/es/baby-talking",
    meta: baby_45talkingEHYq9KDQYBBIn5odRSaQ4hdxUohycp_c5LPxXltABQgMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/baby-talking.vue")
  },
  {
    name: "baby-talking___fr",
    path: "/fr/baby-talking",
    meta: baby_45talkingEHYq9KDQYBBIn5odRSaQ4hdxUohycp_c5LPxXltABQgMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/baby-talking.vue")
  },
  {
    name: "baby-talking___it",
    path: "/it/baby-talking",
    meta: baby_45talkingEHYq9KDQYBBIn5odRSaQ4hdxUohycp_c5LPxXltABQgMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/baby-talking.vue")
  },
  {
    name: "baby-talking___kr",
    path: "/kr/baby-talking",
    meta: baby_45talkingEHYq9KDQYBBIn5odRSaQ4hdxUohycp_c5LPxXltABQgMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/baby-talking.vue")
  },
  {
    name: "baby-talking___nl",
    path: "/nl/baby-talking",
    meta: baby_45talkingEHYq9KDQYBBIn5odRSaQ4hdxUohycp_c5LPxXltABQgMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/baby-talking.vue")
  },
  {
    name: "baby-talking___pt",
    path: "/pt/baby-talking",
    meta: baby_45talkingEHYq9KDQYBBIn5odRSaQ4hdxUohycp_c5LPxXltABQgMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/baby-talking.vue")
  },
  {
    name: "baby-talking___tr",
    path: "/tr/baby-talking",
    meta: baby_45talkingEHYq9KDQYBBIn5odRSaQ4hdxUohycp_c5LPxXltABQgMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/baby-talking.vue")
  },
  {
    name: "baby-talking___zh",
    path: "/zh/baby-talking",
    meta: baby_45talkingEHYq9KDQYBBIn5odRSaQ4hdxUohycp_c5LPxXltABQgMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/baby-talking.vue")
  },
  {
    name: "my-creations___en",
    path: "/my-creations",
    meta: { ...(my_45creations_45kd_7rSduKUp245_45wHwnq_45hgjq0VU_45Zf0tFb0SvTuRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/my-creations.vue")
  },
  {
    name: "my-creations___ru",
    path: "/ru/my-creations",
    meta: { ...(my_45creations_45kd_7rSduKUp245_45wHwnq_45hgjq0VU_45Zf0tFb0SvTuRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/my-creations.vue")
  },
  {
    name: "my-creations___ja",
    path: "/ja/my-creations",
    meta: { ...(my_45creations_45kd_7rSduKUp245_45wHwnq_45hgjq0VU_45Zf0tFb0SvTuRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/my-creations.vue")
  },
  {
    name: "my-creations___id",
    path: "/id/my-creations",
    meta: { ...(my_45creations_45kd_7rSduKUp245_45wHwnq_45hgjq0VU_45Zf0tFb0SvTuRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/my-creations.vue")
  },
  {
    name: "my-creations___ar",
    path: "/ar/my-creations",
    meta: { ...(my_45creations_45kd_7rSduKUp245_45wHwnq_45hgjq0VU_45Zf0tFb0SvTuRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/my-creations.vue")
  },
  {
    name: "my-creations___cn",
    path: "/cn/my-creations",
    meta: { ...(my_45creations_45kd_7rSduKUp245_45wHwnq_45hgjq0VU_45Zf0tFb0SvTuRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/my-creations.vue")
  },
  {
    name: "my-creations___de",
    path: "/de/my-creations",
    meta: { ...(my_45creations_45kd_7rSduKUp245_45wHwnq_45hgjq0VU_45Zf0tFb0SvTuRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/my-creations.vue")
  },
  {
    name: "my-creations___es",
    path: "/es/my-creations",
    meta: { ...(my_45creations_45kd_7rSduKUp245_45wHwnq_45hgjq0VU_45Zf0tFb0SvTuRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/my-creations.vue")
  },
  {
    name: "my-creations___fr",
    path: "/fr/my-creations",
    meta: { ...(my_45creations_45kd_7rSduKUp245_45wHwnq_45hgjq0VU_45Zf0tFb0SvTuRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/my-creations.vue")
  },
  {
    name: "my-creations___it",
    path: "/it/my-creations",
    meta: { ...(my_45creations_45kd_7rSduKUp245_45wHwnq_45hgjq0VU_45Zf0tFb0SvTuRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/my-creations.vue")
  },
  {
    name: "my-creations___kr",
    path: "/kr/my-creations",
    meta: { ...(my_45creations_45kd_7rSduKUp245_45wHwnq_45hgjq0VU_45Zf0tFb0SvTuRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/my-creations.vue")
  },
  {
    name: "my-creations___nl",
    path: "/nl/my-creations",
    meta: { ...(my_45creations_45kd_7rSduKUp245_45wHwnq_45hgjq0VU_45Zf0tFb0SvTuRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/my-creations.vue")
  },
  {
    name: "my-creations___pt",
    path: "/pt/my-creations",
    meta: { ...(my_45creations_45kd_7rSduKUp245_45wHwnq_45hgjq0VU_45Zf0tFb0SvTuRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/my-creations.vue")
  },
  {
    name: "my-creations___tr",
    path: "/tr/my-creations",
    meta: { ...(my_45creations_45kd_7rSduKUp245_45wHwnq_45hgjq0VU_45Zf0tFb0SvTuRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/my-creations.vue")
  },
  {
    name: "my-creations___zh",
    path: "/zh/my-creations",
    meta: { ...(my_45creations_45kd_7rSduKUp245_45wHwnq_45hgjq0VU_45Zf0tFb0SvTuRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/my-creations.vue")
  },
  {
    name: "audio-cleaner___en",
    path: "/audio-cleaner",
    meta: audio_45cleanerzXS8JMblLu6W1j_tLrdvLanW4IOtB00_455TEPM86IXRYMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/audio-cleaner.vue")
  },
  {
    name: "audio-cleaner___ru",
    path: "/ru/audio-cleaner",
    meta: audio_45cleanerzXS8JMblLu6W1j_tLrdvLanW4IOtB00_455TEPM86IXRYMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/audio-cleaner.vue")
  },
  {
    name: "audio-cleaner___ja",
    path: "/ja/audio-cleaner",
    meta: audio_45cleanerzXS8JMblLu6W1j_tLrdvLanW4IOtB00_455TEPM86IXRYMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/audio-cleaner.vue")
  },
  {
    name: "audio-cleaner___id",
    path: "/id/audio-cleaner",
    meta: audio_45cleanerzXS8JMblLu6W1j_tLrdvLanW4IOtB00_455TEPM86IXRYMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/audio-cleaner.vue")
  },
  {
    name: "audio-cleaner___ar",
    path: "/ar/audio-cleaner",
    meta: audio_45cleanerzXS8JMblLu6W1j_tLrdvLanW4IOtB00_455TEPM86IXRYMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/audio-cleaner.vue")
  },
  {
    name: "audio-cleaner___cn",
    path: "/cn/audio-cleaner",
    meta: audio_45cleanerzXS8JMblLu6W1j_tLrdvLanW4IOtB00_455TEPM86IXRYMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/audio-cleaner.vue")
  },
  {
    name: "audio-cleaner___de",
    path: "/de/audio-cleaner",
    meta: audio_45cleanerzXS8JMblLu6W1j_tLrdvLanW4IOtB00_455TEPM86IXRYMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/audio-cleaner.vue")
  },
  {
    name: "audio-cleaner___es",
    path: "/es/audio-cleaner",
    meta: audio_45cleanerzXS8JMblLu6W1j_tLrdvLanW4IOtB00_455TEPM86IXRYMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/audio-cleaner.vue")
  },
  {
    name: "audio-cleaner___fr",
    path: "/fr/audio-cleaner",
    meta: audio_45cleanerzXS8JMblLu6W1j_tLrdvLanW4IOtB00_455TEPM86IXRYMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/audio-cleaner.vue")
  },
  {
    name: "audio-cleaner___it",
    path: "/it/audio-cleaner",
    meta: audio_45cleanerzXS8JMblLu6W1j_tLrdvLanW4IOtB00_455TEPM86IXRYMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/audio-cleaner.vue")
  },
  {
    name: "audio-cleaner___kr",
    path: "/kr/audio-cleaner",
    meta: audio_45cleanerzXS8JMblLu6W1j_tLrdvLanW4IOtB00_455TEPM86IXRYMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/audio-cleaner.vue")
  },
  {
    name: "audio-cleaner___nl",
    path: "/nl/audio-cleaner",
    meta: audio_45cleanerzXS8JMblLu6W1j_tLrdvLanW4IOtB00_455TEPM86IXRYMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/audio-cleaner.vue")
  },
  {
    name: "audio-cleaner___pt",
    path: "/pt/audio-cleaner",
    meta: audio_45cleanerzXS8JMblLu6W1j_tLrdvLanW4IOtB00_455TEPM86IXRYMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/audio-cleaner.vue")
  },
  {
    name: "audio-cleaner___tr",
    path: "/tr/audio-cleaner",
    meta: audio_45cleanerzXS8JMblLu6W1j_tLrdvLanW4IOtB00_455TEPM86IXRYMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/audio-cleaner.vue")
  },
  {
    name: "audio-cleaner___zh",
    path: "/zh/audio-cleaner",
    meta: audio_45cleanerzXS8JMblLu6W1j_tLrdvLanW4IOtB00_455TEPM86IXRYMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/audio-cleaner.vue")
  },
  {
    name: "voice-cloning___en",
    path: "/voice-cloning",
    meta: voice_45cloningh9UHT5pb3_IyyRP3g0UpSFVIVQBXMnC_45FMUDGoJDtucMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/voice-cloning.vue")
  },
  {
    name: "voice-cloning___ru",
    path: "/ru/voice-cloning",
    meta: voice_45cloningh9UHT5pb3_IyyRP3g0UpSFVIVQBXMnC_45FMUDGoJDtucMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/voice-cloning.vue")
  },
  {
    name: "voice-cloning___ja",
    path: "/ja/voice-cloning",
    meta: voice_45cloningh9UHT5pb3_IyyRP3g0UpSFVIVQBXMnC_45FMUDGoJDtucMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/voice-cloning.vue")
  },
  {
    name: "voice-cloning___id",
    path: "/id/voice-cloning",
    meta: voice_45cloningh9UHT5pb3_IyyRP3g0UpSFVIVQBXMnC_45FMUDGoJDtucMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/voice-cloning.vue")
  },
  {
    name: "voice-cloning___ar",
    path: "/ar/voice-cloning",
    meta: voice_45cloningh9UHT5pb3_IyyRP3g0UpSFVIVQBXMnC_45FMUDGoJDtucMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/voice-cloning.vue")
  },
  {
    name: "voice-cloning___cn",
    path: "/cn/voice-cloning",
    meta: voice_45cloningh9UHT5pb3_IyyRP3g0UpSFVIVQBXMnC_45FMUDGoJDtucMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/voice-cloning.vue")
  },
  {
    name: "voice-cloning___de",
    path: "/de/voice-cloning",
    meta: voice_45cloningh9UHT5pb3_IyyRP3g0UpSFVIVQBXMnC_45FMUDGoJDtucMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/voice-cloning.vue")
  },
  {
    name: "voice-cloning___es",
    path: "/es/voice-cloning",
    meta: voice_45cloningh9UHT5pb3_IyyRP3g0UpSFVIVQBXMnC_45FMUDGoJDtucMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/voice-cloning.vue")
  },
  {
    name: "voice-cloning___fr",
    path: "/fr/voice-cloning",
    meta: voice_45cloningh9UHT5pb3_IyyRP3g0UpSFVIVQBXMnC_45FMUDGoJDtucMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/voice-cloning.vue")
  },
  {
    name: "voice-cloning___it",
    path: "/it/voice-cloning",
    meta: voice_45cloningh9UHT5pb3_IyyRP3g0UpSFVIVQBXMnC_45FMUDGoJDtucMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/voice-cloning.vue")
  },
  {
    name: "voice-cloning___kr",
    path: "/kr/voice-cloning",
    meta: voice_45cloningh9UHT5pb3_IyyRP3g0UpSFVIVQBXMnC_45FMUDGoJDtucMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/voice-cloning.vue")
  },
  {
    name: "voice-cloning___nl",
    path: "/nl/voice-cloning",
    meta: voice_45cloningh9UHT5pb3_IyyRP3g0UpSFVIVQBXMnC_45FMUDGoJDtucMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/voice-cloning.vue")
  },
  {
    name: "voice-cloning___pt",
    path: "/pt/voice-cloning",
    meta: voice_45cloningh9UHT5pb3_IyyRP3g0UpSFVIVQBXMnC_45FMUDGoJDtucMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/voice-cloning.vue")
  },
  {
    name: "voice-cloning___tr",
    path: "/tr/voice-cloning",
    meta: voice_45cloningh9UHT5pb3_IyyRP3g0UpSFVIVQBXMnC_45FMUDGoJDtucMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/voice-cloning.vue")
  },
  {
    name: "voice-cloning___zh",
    path: "/zh/voice-cloning",
    meta: voice_45cloningh9UHT5pb3_IyyRP3g0UpSFVIVQBXMnC_45FMUDGoJDtucMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/voice-cloning.vue")
  },
  {
    name: "ai-news-anchor___en",
    path: "/ai-news-anchor",
    meta: ai_45news_45anchorkiOOVwypoDdLGcFhB_Liox3q2M3Uh_45qawXWOaJ9YrrIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-news-anchor.vue")
  },
  {
    name: "ai-news-anchor___ru",
    path: "/ru/ai-news-anchor",
    meta: ai_45news_45anchorkiOOVwypoDdLGcFhB_Liox3q2M3Uh_45qawXWOaJ9YrrIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-news-anchor.vue")
  },
  {
    name: "ai-news-anchor___ja",
    path: "/ja/ai-news-anchor",
    meta: ai_45news_45anchorkiOOVwypoDdLGcFhB_Liox3q2M3Uh_45qawXWOaJ9YrrIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-news-anchor.vue")
  },
  {
    name: "ai-news-anchor___id",
    path: "/id/ai-news-anchor",
    meta: ai_45news_45anchorkiOOVwypoDdLGcFhB_Liox3q2M3Uh_45qawXWOaJ9YrrIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-news-anchor.vue")
  },
  {
    name: "ai-news-anchor___ar",
    path: "/ar/ai-news-anchor",
    meta: ai_45news_45anchorkiOOVwypoDdLGcFhB_Liox3q2M3Uh_45qawXWOaJ9YrrIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-news-anchor.vue")
  },
  {
    name: "ai-news-anchor___cn",
    path: "/cn/ai-news-anchor",
    meta: ai_45news_45anchorkiOOVwypoDdLGcFhB_Liox3q2M3Uh_45qawXWOaJ9YrrIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-news-anchor.vue")
  },
  {
    name: "ai-news-anchor___de",
    path: "/de/ai-news-anchor",
    meta: ai_45news_45anchorkiOOVwypoDdLGcFhB_Liox3q2M3Uh_45qawXWOaJ9YrrIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-news-anchor.vue")
  },
  {
    name: "ai-news-anchor___es",
    path: "/es/ai-news-anchor",
    meta: ai_45news_45anchorkiOOVwypoDdLGcFhB_Liox3q2M3Uh_45qawXWOaJ9YrrIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-news-anchor.vue")
  },
  {
    name: "ai-news-anchor___fr",
    path: "/fr/ai-news-anchor",
    meta: ai_45news_45anchorkiOOVwypoDdLGcFhB_Liox3q2M3Uh_45qawXWOaJ9YrrIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-news-anchor.vue")
  },
  {
    name: "ai-news-anchor___it",
    path: "/it/ai-news-anchor",
    meta: ai_45news_45anchorkiOOVwypoDdLGcFhB_Liox3q2M3Uh_45qawXWOaJ9YrrIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-news-anchor.vue")
  },
  {
    name: "ai-news-anchor___kr",
    path: "/kr/ai-news-anchor",
    meta: ai_45news_45anchorkiOOVwypoDdLGcFhB_Liox3q2M3Uh_45qawXWOaJ9YrrIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-news-anchor.vue")
  },
  {
    name: "ai-news-anchor___nl",
    path: "/nl/ai-news-anchor",
    meta: ai_45news_45anchorkiOOVwypoDdLGcFhB_Liox3q2M3Uh_45qawXWOaJ9YrrIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-news-anchor.vue")
  },
  {
    name: "ai-news-anchor___pt",
    path: "/pt/ai-news-anchor",
    meta: ai_45news_45anchorkiOOVwypoDdLGcFhB_Liox3q2M3Uh_45qawXWOaJ9YrrIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-news-anchor.vue")
  },
  {
    name: "ai-news-anchor___tr",
    path: "/tr/ai-news-anchor",
    meta: ai_45news_45anchorkiOOVwypoDdLGcFhB_Liox3q2M3Uh_45qawXWOaJ9YrrIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-news-anchor.vue")
  },
  {
    name: "ai-news-anchor___zh",
    path: "/zh/ai-news-anchor",
    meta: ai_45news_45anchorkiOOVwypoDdLGcFhB_Liox3q2M3Uh_45qawXWOaJ9YrrIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-news-anchor.vue")
  },
  {
    name: "audio-enhancer___en",
    path: "/audio-enhancer",
    meta: audio_45enhancert7nUNRo4UmaqYmlpA19IKrCmfmxSCWp59L_M1F2Hjb0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/audio-enhancer.vue")
  },
  {
    name: "audio-enhancer___ru",
    path: "/ru/audio-enhancer",
    meta: audio_45enhancert7nUNRo4UmaqYmlpA19IKrCmfmxSCWp59L_M1F2Hjb0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/audio-enhancer.vue")
  },
  {
    name: "audio-enhancer___ja",
    path: "/ja/audio-enhancer",
    meta: audio_45enhancert7nUNRo4UmaqYmlpA19IKrCmfmxSCWp59L_M1F2Hjb0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/audio-enhancer.vue")
  },
  {
    name: "audio-enhancer___id",
    path: "/id/audio-enhancer",
    meta: audio_45enhancert7nUNRo4UmaqYmlpA19IKrCmfmxSCWp59L_M1F2Hjb0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/audio-enhancer.vue")
  },
  {
    name: "audio-enhancer___ar",
    path: "/ar/audio-enhancer",
    meta: audio_45enhancert7nUNRo4UmaqYmlpA19IKrCmfmxSCWp59L_M1F2Hjb0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/audio-enhancer.vue")
  },
  {
    name: "audio-enhancer___cn",
    path: "/cn/audio-enhancer",
    meta: audio_45enhancert7nUNRo4UmaqYmlpA19IKrCmfmxSCWp59L_M1F2Hjb0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/audio-enhancer.vue")
  },
  {
    name: "audio-enhancer___de",
    path: "/de/audio-enhancer",
    meta: audio_45enhancert7nUNRo4UmaqYmlpA19IKrCmfmxSCWp59L_M1F2Hjb0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/audio-enhancer.vue")
  },
  {
    name: "audio-enhancer___es",
    path: "/es/audio-enhancer",
    meta: audio_45enhancert7nUNRo4UmaqYmlpA19IKrCmfmxSCWp59L_M1F2Hjb0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/audio-enhancer.vue")
  },
  {
    name: "audio-enhancer___fr",
    path: "/fr/audio-enhancer",
    meta: audio_45enhancert7nUNRo4UmaqYmlpA19IKrCmfmxSCWp59L_M1F2Hjb0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/audio-enhancer.vue")
  },
  {
    name: "audio-enhancer___it",
    path: "/it/audio-enhancer",
    meta: audio_45enhancert7nUNRo4UmaqYmlpA19IKrCmfmxSCWp59L_M1F2Hjb0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/audio-enhancer.vue")
  },
  {
    name: "audio-enhancer___kr",
    path: "/kr/audio-enhancer",
    meta: audio_45enhancert7nUNRo4UmaqYmlpA19IKrCmfmxSCWp59L_M1F2Hjb0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/audio-enhancer.vue")
  },
  {
    name: "audio-enhancer___nl",
    path: "/nl/audio-enhancer",
    meta: audio_45enhancert7nUNRo4UmaqYmlpA19IKrCmfmxSCWp59L_M1F2Hjb0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/audio-enhancer.vue")
  },
  {
    name: "audio-enhancer___pt",
    path: "/pt/audio-enhancer",
    meta: audio_45enhancert7nUNRo4UmaqYmlpA19IKrCmfmxSCWp59L_M1F2Hjb0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/audio-enhancer.vue")
  },
  {
    name: "audio-enhancer___tr",
    path: "/tr/audio-enhancer",
    meta: audio_45enhancert7nUNRo4UmaqYmlpA19IKrCmfmxSCWp59L_M1F2Hjb0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/audio-enhancer.vue")
  },
  {
    name: "audio-enhancer___zh",
    path: "/zh/audio-enhancer",
    meta: audio_45enhancert7nUNRo4UmaqYmlpA19IKrCmfmxSCWp59L_M1F2Hjb0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/audio-enhancer.vue")
  },
  {
    name: "privacy-policy___en",
    path: "/privacy-policy",
    meta: { ...(privacy_45policyXSpcM6iJsMNvcAxvlcB6tAsWktQXUftehnc22jfBB50Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___ru",
    path: "/ru/privacy-policy",
    meta: { ...(privacy_45policyXSpcM6iJsMNvcAxvlcB6tAsWktQXUftehnc22jfBB50Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___ja",
    path: "/ja/privacy-policy",
    meta: { ...(privacy_45policyXSpcM6iJsMNvcAxvlcB6tAsWktQXUftehnc22jfBB50Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___id",
    path: "/id/privacy-policy",
    meta: { ...(privacy_45policyXSpcM6iJsMNvcAxvlcB6tAsWktQXUftehnc22jfBB50Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___ar",
    path: "/ar/privacy-policy",
    meta: { ...(privacy_45policyXSpcM6iJsMNvcAxvlcB6tAsWktQXUftehnc22jfBB50Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___cn",
    path: "/cn/privacy-policy",
    meta: { ...(privacy_45policyXSpcM6iJsMNvcAxvlcB6tAsWktQXUftehnc22jfBB50Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___de",
    path: "/de/privacy-policy",
    meta: { ...(privacy_45policyXSpcM6iJsMNvcAxvlcB6tAsWktQXUftehnc22jfBB50Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___es",
    path: "/es/privacy-policy",
    meta: { ...(privacy_45policyXSpcM6iJsMNvcAxvlcB6tAsWktQXUftehnc22jfBB50Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___fr",
    path: "/fr/privacy-policy",
    meta: { ...(privacy_45policyXSpcM6iJsMNvcAxvlcB6tAsWktQXUftehnc22jfBB50Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___it",
    path: "/it/privacy-policy",
    meta: { ...(privacy_45policyXSpcM6iJsMNvcAxvlcB6tAsWktQXUftehnc22jfBB50Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___kr",
    path: "/kr/privacy-policy",
    meta: { ...(privacy_45policyXSpcM6iJsMNvcAxvlcB6tAsWktQXUftehnc22jfBB50Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___nl",
    path: "/nl/privacy-policy",
    meta: { ...(privacy_45policyXSpcM6iJsMNvcAxvlcB6tAsWktQXUftehnc22jfBB50Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___pt",
    path: "/pt/privacy-policy",
    meta: { ...(privacy_45policyXSpcM6iJsMNvcAxvlcB6tAsWktQXUftehnc22jfBB50Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___tr",
    path: "/tr/privacy-policy",
    meta: { ...(privacy_45policyXSpcM6iJsMNvcAxvlcB6tAsWktQXUftehnc22jfBB50Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___zh",
    path: "/zh/privacy-policy",
    meta: { ...(privacy_45policyXSpcM6iJsMNvcAxvlcB6tAsWktQXUftehnc22jfBB50Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/privacy-policy.vue")
  },
  {
    name: "product-avatar___en",
    path: "/product-avatar",
    meta: product_45avatarFLt0beE3xM5wiqfQ94cbIDIczWcXqnjb9sBjBFQP75YMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/product-avatar.vue")
  },
  {
    name: "product-avatar___ru",
    path: "/ru/product-avatar",
    meta: product_45avatarFLt0beE3xM5wiqfQ94cbIDIczWcXqnjb9sBjBFQP75YMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/product-avatar.vue")
  },
  {
    name: "product-avatar___ja",
    path: "/ja/product-avatar",
    meta: product_45avatarFLt0beE3xM5wiqfQ94cbIDIczWcXqnjb9sBjBFQP75YMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/product-avatar.vue")
  },
  {
    name: "product-avatar___id",
    path: "/id/product-avatar",
    meta: product_45avatarFLt0beE3xM5wiqfQ94cbIDIczWcXqnjb9sBjBFQP75YMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/product-avatar.vue")
  },
  {
    name: "product-avatar___ar",
    path: "/ar/product-avatar",
    meta: product_45avatarFLt0beE3xM5wiqfQ94cbIDIczWcXqnjb9sBjBFQP75YMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/product-avatar.vue")
  },
  {
    name: "product-avatar___cn",
    path: "/cn/product-avatar",
    meta: product_45avatarFLt0beE3xM5wiqfQ94cbIDIczWcXqnjb9sBjBFQP75YMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/product-avatar.vue")
  },
  {
    name: "product-avatar___de",
    path: "/de/product-avatar",
    meta: product_45avatarFLt0beE3xM5wiqfQ94cbIDIczWcXqnjb9sBjBFQP75YMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/product-avatar.vue")
  },
  {
    name: "product-avatar___es",
    path: "/es/product-avatar",
    meta: product_45avatarFLt0beE3xM5wiqfQ94cbIDIczWcXqnjb9sBjBFQP75YMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/product-avatar.vue")
  },
  {
    name: "product-avatar___fr",
    path: "/fr/product-avatar",
    meta: product_45avatarFLt0beE3xM5wiqfQ94cbIDIczWcXqnjb9sBjBFQP75YMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/product-avatar.vue")
  },
  {
    name: "product-avatar___it",
    path: "/it/product-avatar",
    meta: product_45avatarFLt0beE3xM5wiqfQ94cbIDIczWcXqnjb9sBjBFQP75YMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/product-avatar.vue")
  },
  {
    name: "product-avatar___kr",
    path: "/kr/product-avatar",
    meta: product_45avatarFLt0beE3xM5wiqfQ94cbIDIczWcXqnjb9sBjBFQP75YMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/product-avatar.vue")
  },
  {
    name: "product-avatar___nl",
    path: "/nl/product-avatar",
    meta: product_45avatarFLt0beE3xM5wiqfQ94cbIDIczWcXqnjb9sBjBFQP75YMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/product-avatar.vue")
  },
  {
    name: "product-avatar___pt",
    path: "/pt/product-avatar",
    meta: product_45avatarFLt0beE3xM5wiqfQ94cbIDIczWcXqnjb9sBjBFQP75YMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/product-avatar.vue")
  },
  {
    name: "product-avatar___tr",
    path: "/tr/product-avatar",
    meta: product_45avatarFLt0beE3xM5wiqfQ94cbIDIczWcXqnjb9sBjBFQP75YMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/product-avatar.vue")
  },
  {
    name: "product-avatar___zh",
    path: "/zh/product-avatar",
    meta: product_45avatarFLt0beE3xM5wiqfQ94cbIDIczWcXqnjb9sBjBFQP75YMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/product-avatar.vue")
  },
  {
    name: "talking-avatar___en",
    path: "/talking-avatar",
    meta: talking_45avatar_45n95qXJsFMz4UvllwoWBxhzIDnogWnr058Dad1_45FXyUMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-avatar.vue")
  },
  {
    name: "talking-avatar___ru",
    path: "/ru/talking-avatar",
    meta: talking_45avatar_45n95qXJsFMz4UvllwoWBxhzIDnogWnr058Dad1_45FXyUMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-avatar.vue")
  },
  {
    name: "talking-avatar___ja",
    path: "/ja/talking-avatar",
    meta: talking_45avatar_45n95qXJsFMz4UvllwoWBxhzIDnogWnr058Dad1_45FXyUMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-avatar.vue")
  },
  {
    name: "talking-avatar___id",
    path: "/id/talking-avatar",
    meta: talking_45avatar_45n95qXJsFMz4UvllwoWBxhzIDnogWnr058Dad1_45FXyUMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-avatar.vue")
  },
  {
    name: "talking-avatar___ar",
    path: "/ar/talking-avatar",
    meta: talking_45avatar_45n95qXJsFMz4UvllwoWBxhzIDnogWnr058Dad1_45FXyUMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-avatar.vue")
  },
  {
    name: "talking-avatar___cn",
    path: "/cn/talking-avatar",
    meta: talking_45avatar_45n95qXJsFMz4UvllwoWBxhzIDnogWnr058Dad1_45FXyUMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-avatar.vue")
  },
  {
    name: "talking-avatar___de",
    path: "/de/talking-avatar",
    meta: talking_45avatar_45n95qXJsFMz4UvllwoWBxhzIDnogWnr058Dad1_45FXyUMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-avatar.vue")
  },
  {
    name: "talking-avatar___es",
    path: "/es/talking-avatar",
    meta: talking_45avatar_45n95qXJsFMz4UvllwoWBxhzIDnogWnr058Dad1_45FXyUMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-avatar.vue")
  },
  {
    name: "talking-avatar___fr",
    path: "/fr/talking-avatar",
    meta: talking_45avatar_45n95qXJsFMz4UvllwoWBxhzIDnogWnr058Dad1_45FXyUMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-avatar.vue")
  },
  {
    name: "talking-avatar___it",
    path: "/it/talking-avatar",
    meta: talking_45avatar_45n95qXJsFMz4UvllwoWBxhzIDnogWnr058Dad1_45FXyUMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-avatar.vue")
  },
  {
    name: "talking-avatar___kr",
    path: "/kr/talking-avatar",
    meta: talking_45avatar_45n95qXJsFMz4UvllwoWBxhzIDnogWnr058Dad1_45FXyUMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-avatar.vue")
  },
  {
    name: "talking-avatar___nl",
    path: "/nl/talking-avatar",
    meta: talking_45avatar_45n95qXJsFMz4UvllwoWBxhzIDnogWnr058Dad1_45FXyUMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-avatar.vue")
  },
  {
    name: "talking-avatar___pt",
    path: "/pt/talking-avatar",
    meta: talking_45avatar_45n95qXJsFMz4UvllwoWBxhzIDnogWnr058Dad1_45FXyUMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-avatar.vue")
  },
  {
    name: "talking-avatar___tr",
    path: "/tr/talking-avatar",
    meta: talking_45avatar_45n95qXJsFMz4UvllwoWBxhzIDnogWnr058Dad1_45FXyUMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-avatar.vue")
  },
  {
    name: "talking-avatar___zh",
    path: "/zh/talking-avatar",
    meta: talking_45avatar_45n95qXJsFMz4UvllwoWBxhzIDnogWnr058Dad1_45FXyUMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-avatar.vue")
  },
  {
    name: "ai-baby-podcast___en",
    path: "/ai-baby-podcast",
    meta: ai_45baby_45podcast0nW2NZ6Y9u3jzvV1CMcg5WNYwP_bdjHg_45gsnEjU1wQQMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-baby-podcast.vue")
  },
  {
    name: "ai-baby-podcast___ru",
    path: "/ru/ai-baby-podcast",
    meta: ai_45baby_45podcast0nW2NZ6Y9u3jzvV1CMcg5WNYwP_bdjHg_45gsnEjU1wQQMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-baby-podcast.vue")
  },
  {
    name: "ai-baby-podcast___ja",
    path: "/ja/ai-baby-podcast",
    meta: ai_45baby_45podcast0nW2NZ6Y9u3jzvV1CMcg5WNYwP_bdjHg_45gsnEjU1wQQMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-baby-podcast.vue")
  },
  {
    name: "ai-baby-podcast___id",
    path: "/id/ai-baby-podcast",
    meta: ai_45baby_45podcast0nW2NZ6Y9u3jzvV1CMcg5WNYwP_bdjHg_45gsnEjU1wQQMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-baby-podcast.vue")
  },
  {
    name: "ai-baby-podcast___ar",
    path: "/ar/ai-baby-podcast",
    meta: ai_45baby_45podcast0nW2NZ6Y9u3jzvV1CMcg5WNYwP_bdjHg_45gsnEjU1wQQMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-baby-podcast.vue")
  },
  {
    name: "ai-baby-podcast___cn",
    path: "/cn/ai-baby-podcast",
    meta: ai_45baby_45podcast0nW2NZ6Y9u3jzvV1CMcg5WNYwP_bdjHg_45gsnEjU1wQQMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-baby-podcast.vue")
  },
  {
    name: "ai-baby-podcast___de",
    path: "/de/ai-baby-podcast",
    meta: ai_45baby_45podcast0nW2NZ6Y9u3jzvV1CMcg5WNYwP_bdjHg_45gsnEjU1wQQMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-baby-podcast.vue")
  },
  {
    name: "ai-baby-podcast___es",
    path: "/es/ai-baby-podcast",
    meta: ai_45baby_45podcast0nW2NZ6Y9u3jzvV1CMcg5WNYwP_bdjHg_45gsnEjU1wQQMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-baby-podcast.vue")
  },
  {
    name: "ai-baby-podcast___fr",
    path: "/fr/ai-baby-podcast",
    meta: ai_45baby_45podcast0nW2NZ6Y9u3jzvV1CMcg5WNYwP_bdjHg_45gsnEjU1wQQMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-baby-podcast.vue")
  },
  {
    name: "ai-baby-podcast___it",
    path: "/it/ai-baby-podcast",
    meta: ai_45baby_45podcast0nW2NZ6Y9u3jzvV1CMcg5WNYwP_bdjHg_45gsnEjU1wQQMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-baby-podcast.vue")
  },
  {
    name: "ai-baby-podcast___kr",
    path: "/kr/ai-baby-podcast",
    meta: ai_45baby_45podcast0nW2NZ6Y9u3jzvV1CMcg5WNYwP_bdjHg_45gsnEjU1wQQMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-baby-podcast.vue")
  },
  {
    name: "ai-baby-podcast___nl",
    path: "/nl/ai-baby-podcast",
    meta: ai_45baby_45podcast0nW2NZ6Y9u3jzvV1CMcg5WNYwP_bdjHg_45gsnEjU1wQQMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-baby-podcast.vue")
  },
  {
    name: "ai-baby-podcast___pt",
    path: "/pt/ai-baby-podcast",
    meta: ai_45baby_45podcast0nW2NZ6Y9u3jzvV1CMcg5WNYwP_bdjHg_45gsnEjU1wQQMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-baby-podcast.vue")
  },
  {
    name: "ai-baby-podcast___tr",
    path: "/tr/ai-baby-podcast",
    meta: ai_45baby_45podcast0nW2NZ6Y9u3jzvV1CMcg5WNYwP_bdjHg_45gsnEjU1wQQMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-baby-podcast.vue")
  },
  {
    name: "ai-baby-podcast___zh",
    path: "/zh/ai-baby-podcast",
    meta: ai_45baby_45podcast0nW2NZ6Y9u3jzvV1CMcg5WNYwP_bdjHg_45gsnEjU1wQQMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-baby-podcast.vue")
  },
  {
    name: "avatar-dialogue___en",
    path: "/avatar-dialogue",
    meta: avatar_45dialogue2MP9G4w7D5hGYvAYh5MVhGKBsunZ23fyQSDreglAs7QMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/avatar-dialogue.vue")
  },
  {
    name: "avatar-dialogue___ru",
    path: "/ru/avatar-dialogue",
    meta: avatar_45dialogue2MP9G4w7D5hGYvAYh5MVhGKBsunZ23fyQSDreglAs7QMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/avatar-dialogue.vue")
  },
  {
    name: "avatar-dialogue___ja",
    path: "/ja/avatar-dialogue",
    meta: avatar_45dialogue2MP9G4w7D5hGYvAYh5MVhGKBsunZ23fyQSDreglAs7QMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/avatar-dialogue.vue")
  },
  {
    name: "avatar-dialogue___id",
    path: "/id/avatar-dialogue",
    meta: avatar_45dialogue2MP9G4w7D5hGYvAYh5MVhGKBsunZ23fyQSDreglAs7QMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/avatar-dialogue.vue")
  },
  {
    name: "avatar-dialogue___ar",
    path: "/ar/avatar-dialogue",
    meta: avatar_45dialogue2MP9G4w7D5hGYvAYh5MVhGKBsunZ23fyQSDreglAs7QMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/avatar-dialogue.vue")
  },
  {
    name: "avatar-dialogue___cn",
    path: "/cn/avatar-dialogue",
    meta: avatar_45dialogue2MP9G4w7D5hGYvAYh5MVhGKBsunZ23fyQSDreglAs7QMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/avatar-dialogue.vue")
  },
  {
    name: "avatar-dialogue___de",
    path: "/de/avatar-dialogue",
    meta: avatar_45dialogue2MP9G4w7D5hGYvAYh5MVhGKBsunZ23fyQSDreglAs7QMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/avatar-dialogue.vue")
  },
  {
    name: "avatar-dialogue___es",
    path: "/es/avatar-dialogue",
    meta: avatar_45dialogue2MP9G4w7D5hGYvAYh5MVhGKBsunZ23fyQSDreglAs7QMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/avatar-dialogue.vue")
  },
  {
    name: "avatar-dialogue___fr",
    path: "/fr/avatar-dialogue",
    meta: avatar_45dialogue2MP9G4w7D5hGYvAYh5MVhGKBsunZ23fyQSDreglAs7QMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/avatar-dialogue.vue")
  },
  {
    name: "avatar-dialogue___it",
    path: "/it/avatar-dialogue",
    meta: avatar_45dialogue2MP9G4w7D5hGYvAYh5MVhGKBsunZ23fyQSDreglAs7QMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/avatar-dialogue.vue")
  },
  {
    name: "avatar-dialogue___kr",
    path: "/kr/avatar-dialogue",
    meta: avatar_45dialogue2MP9G4w7D5hGYvAYh5MVhGKBsunZ23fyQSDreglAs7QMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/avatar-dialogue.vue")
  },
  {
    name: "avatar-dialogue___nl",
    path: "/nl/avatar-dialogue",
    meta: avatar_45dialogue2MP9G4w7D5hGYvAYh5MVhGKBsunZ23fyQSDreglAs7QMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/avatar-dialogue.vue")
  },
  {
    name: "avatar-dialogue___pt",
    path: "/pt/avatar-dialogue",
    meta: avatar_45dialogue2MP9G4w7D5hGYvAYh5MVhGKBsunZ23fyQSDreglAs7QMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/avatar-dialogue.vue")
  },
  {
    name: "avatar-dialogue___tr",
    path: "/tr/avatar-dialogue",
    meta: avatar_45dialogue2MP9G4w7D5hGYvAYh5MVhGKBsunZ23fyQSDreglAs7QMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/avatar-dialogue.vue")
  },
  {
    name: "avatar-dialogue___zh",
    path: "/zh/avatar-dialogue",
    meta: avatar_45dialogue2MP9G4w7D5hGYvAYh5MVhGKBsunZ23fyQSDreglAs7QMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/avatar-dialogue.vue")
  },
  {
    name: "cartoon-singing___en",
    path: "/cartoon-singing",
    meta: cartoon_45singingsStunrhg27FU1GN_ukir6c0LdAfxXp6E0Tr9ZwFja_45YMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/cartoon-singing.vue")
  },
  {
    name: "cartoon-singing___ru",
    path: "/ru/cartoon-singing",
    meta: cartoon_45singingsStunrhg27FU1GN_ukir6c0LdAfxXp6E0Tr9ZwFja_45YMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/cartoon-singing.vue")
  },
  {
    name: "cartoon-singing___ja",
    path: "/ja/cartoon-singing",
    meta: cartoon_45singingsStunrhg27FU1GN_ukir6c0LdAfxXp6E0Tr9ZwFja_45YMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/cartoon-singing.vue")
  },
  {
    name: "cartoon-singing___id",
    path: "/id/cartoon-singing",
    meta: cartoon_45singingsStunrhg27FU1GN_ukir6c0LdAfxXp6E0Tr9ZwFja_45YMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/cartoon-singing.vue")
  },
  {
    name: "cartoon-singing___ar",
    path: "/ar/cartoon-singing",
    meta: cartoon_45singingsStunrhg27FU1GN_ukir6c0LdAfxXp6E0Tr9ZwFja_45YMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/cartoon-singing.vue")
  },
  {
    name: "cartoon-singing___cn",
    path: "/cn/cartoon-singing",
    meta: cartoon_45singingsStunrhg27FU1GN_ukir6c0LdAfxXp6E0Tr9ZwFja_45YMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/cartoon-singing.vue")
  },
  {
    name: "cartoon-singing___de",
    path: "/de/cartoon-singing",
    meta: cartoon_45singingsStunrhg27FU1GN_ukir6c0LdAfxXp6E0Tr9ZwFja_45YMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/cartoon-singing.vue")
  },
  {
    name: "cartoon-singing___es",
    path: "/es/cartoon-singing",
    meta: cartoon_45singingsStunrhg27FU1GN_ukir6c0LdAfxXp6E0Tr9ZwFja_45YMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/cartoon-singing.vue")
  },
  {
    name: "cartoon-singing___fr",
    path: "/fr/cartoon-singing",
    meta: cartoon_45singingsStunrhg27FU1GN_ukir6c0LdAfxXp6E0Tr9ZwFja_45YMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/cartoon-singing.vue")
  },
  {
    name: "cartoon-singing___it",
    path: "/it/cartoon-singing",
    meta: cartoon_45singingsStunrhg27FU1GN_ukir6c0LdAfxXp6E0Tr9ZwFja_45YMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/cartoon-singing.vue")
  },
  {
    name: "cartoon-singing___kr",
    path: "/kr/cartoon-singing",
    meta: cartoon_45singingsStunrhg27FU1GN_ukir6c0LdAfxXp6E0Tr9ZwFja_45YMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/cartoon-singing.vue")
  },
  {
    name: "cartoon-singing___nl",
    path: "/nl/cartoon-singing",
    meta: cartoon_45singingsStunrhg27FU1GN_ukir6c0LdAfxXp6E0Tr9ZwFja_45YMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/cartoon-singing.vue")
  },
  {
    name: "cartoon-singing___pt",
    path: "/pt/cartoon-singing",
    meta: cartoon_45singingsStunrhg27FU1GN_ukir6c0LdAfxXp6E0Tr9ZwFja_45YMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/cartoon-singing.vue")
  },
  {
    name: "cartoon-singing___tr",
    path: "/tr/cartoon-singing",
    meta: cartoon_45singingsStunrhg27FU1GN_ukir6c0LdAfxXp6E0Tr9ZwFja_45YMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/cartoon-singing.vue")
  },
  {
    name: "cartoon-singing___zh",
    path: "/zh/cartoon-singing",
    meta: cartoon_45singingsStunrhg27FU1GN_ukir6c0LdAfxXp6E0Tr9ZwFja_45YMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/cartoon-singing.vue")
  },
  {
    name: "history-lipsync___en",
    path: "/history-lipsync",
    meta: { ...(history_45lipsync3ExyrBeUh6zCH9GyU5BCmTcbDhN_45f_xD7VAgC39zCxgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/history-lipsync.vue")
  },
  {
    name: "history-lipsync___ru",
    path: "/ru/history-lipsync",
    meta: { ...(history_45lipsync3ExyrBeUh6zCH9GyU5BCmTcbDhN_45f_xD7VAgC39zCxgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/history-lipsync.vue")
  },
  {
    name: "history-lipsync___ja",
    path: "/ja/history-lipsync",
    meta: { ...(history_45lipsync3ExyrBeUh6zCH9GyU5BCmTcbDhN_45f_xD7VAgC39zCxgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/history-lipsync.vue")
  },
  {
    name: "history-lipsync___id",
    path: "/id/history-lipsync",
    meta: { ...(history_45lipsync3ExyrBeUh6zCH9GyU5BCmTcbDhN_45f_xD7VAgC39zCxgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/history-lipsync.vue")
  },
  {
    name: "history-lipsync___ar",
    path: "/ar/history-lipsync",
    meta: { ...(history_45lipsync3ExyrBeUh6zCH9GyU5BCmTcbDhN_45f_xD7VAgC39zCxgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/history-lipsync.vue")
  },
  {
    name: "history-lipsync___cn",
    path: "/cn/history-lipsync",
    meta: { ...(history_45lipsync3ExyrBeUh6zCH9GyU5BCmTcbDhN_45f_xD7VAgC39zCxgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/history-lipsync.vue")
  },
  {
    name: "history-lipsync___de",
    path: "/de/history-lipsync",
    meta: { ...(history_45lipsync3ExyrBeUh6zCH9GyU5BCmTcbDhN_45f_xD7VAgC39zCxgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/history-lipsync.vue")
  },
  {
    name: "history-lipsync___es",
    path: "/es/history-lipsync",
    meta: { ...(history_45lipsync3ExyrBeUh6zCH9GyU5BCmTcbDhN_45f_xD7VAgC39zCxgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/history-lipsync.vue")
  },
  {
    name: "history-lipsync___fr",
    path: "/fr/history-lipsync",
    meta: { ...(history_45lipsync3ExyrBeUh6zCH9GyU5BCmTcbDhN_45f_xD7VAgC39zCxgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/history-lipsync.vue")
  },
  {
    name: "history-lipsync___it",
    path: "/it/history-lipsync",
    meta: { ...(history_45lipsync3ExyrBeUh6zCH9GyU5BCmTcbDhN_45f_xD7VAgC39zCxgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/history-lipsync.vue")
  },
  {
    name: "history-lipsync___kr",
    path: "/kr/history-lipsync",
    meta: { ...(history_45lipsync3ExyrBeUh6zCH9GyU5BCmTcbDhN_45f_xD7VAgC39zCxgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/history-lipsync.vue")
  },
  {
    name: "history-lipsync___nl",
    path: "/nl/history-lipsync",
    meta: { ...(history_45lipsync3ExyrBeUh6zCH9GyU5BCmTcbDhN_45f_xD7VAgC39zCxgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/history-lipsync.vue")
  },
  {
    name: "history-lipsync___pt",
    path: "/pt/history-lipsync",
    meta: { ...(history_45lipsync3ExyrBeUh6zCH9GyU5BCmTcbDhN_45f_xD7VAgC39zCxgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/history-lipsync.vue")
  },
  {
    name: "history-lipsync___tr",
    path: "/tr/history-lipsync",
    meta: { ...(history_45lipsync3ExyrBeUh6zCH9GyU5BCmTcbDhN_45f_xD7VAgC39zCxgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/history-lipsync.vue")
  },
  {
    name: "history-lipsync___zh",
    path: "/zh/history-lipsync",
    meta: { ...(history_45lipsync3ExyrBeUh6zCH9GyU5BCmTcbDhN_45f_xD7VAgC39zCxgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/history-lipsync.vue")
  },
  {
    name: "talking-animals___en",
    path: "/talking-animals",
    meta: talking_45animalsOef9AwboIL2Y_45P5Q6Sr6OmBosI5y5nuEYy44F_B8wUsMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-animals.vue")
  },
  {
    name: "talking-animals___ru",
    path: "/ru/talking-animals",
    meta: talking_45animalsOef9AwboIL2Y_45P5Q6Sr6OmBosI5y5nuEYy44F_B8wUsMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-animals.vue")
  },
  {
    name: "talking-animals___ja",
    path: "/ja/talking-animals",
    meta: talking_45animalsOef9AwboIL2Y_45P5Q6Sr6OmBosI5y5nuEYy44F_B8wUsMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-animals.vue")
  },
  {
    name: "talking-animals___id",
    path: "/id/talking-animals",
    meta: talking_45animalsOef9AwboIL2Y_45P5Q6Sr6OmBosI5y5nuEYy44F_B8wUsMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-animals.vue")
  },
  {
    name: "talking-animals___ar",
    path: "/ar/talking-animals",
    meta: talking_45animalsOef9AwboIL2Y_45P5Q6Sr6OmBosI5y5nuEYy44F_B8wUsMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-animals.vue")
  },
  {
    name: "talking-animals___cn",
    path: "/cn/talking-animals",
    meta: talking_45animalsOef9AwboIL2Y_45P5Q6Sr6OmBosI5y5nuEYy44F_B8wUsMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-animals.vue")
  },
  {
    name: "talking-animals___de",
    path: "/de/talking-animals",
    meta: talking_45animalsOef9AwboIL2Y_45P5Q6Sr6OmBosI5y5nuEYy44F_B8wUsMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-animals.vue")
  },
  {
    name: "talking-animals___es",
    path: "/es/talking-animals",
    meta: talking_45animalsOef9AwboIL2Y_45P5Q6Sr6OmBosI5y5nuEYy44F_B8wUsMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-animals.vue")
  },
  {
    name: "talking-animals___fr",
    path: "/fr/talking-animals",
    meta: talking_45animalsOef9AwboIL2Y_45P5Q6Sr6OmBosI5y5nuEYy44F_B8wUsMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-animals.vue")
  },
  {
    name: "talking-animals___it",
    path: "/it/talking-animals",
    meta: talking_45animalsOef9AwboIL2Y_45P5Q6Sr6OmBosI5y5nuEYy44F_B8wUsMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-animals.vue")
  },
  {
    name: "talking-animals___kr",
    path: "/kr/talking-animals",
    meta: talking_45animalsOef9AwboIL2Y_45P5Q6Sr6OmBosI5y5nuEYy44F_B8wUsMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-animals.vue")
  },
  {
    name: "talking-animals___nl",
    path: "/nl/talking-animals",
    meta: talking_45animalsOef9AwboIL2Y_45P5Q6Sr6OmBosI5y5nuEYy44F_B8wUsMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-animals.vue")
  },
  {
    name: "talking-animals___pt",
    path: "/pt/talking-animals",
    meta: talking_45animalsOef9AwboIL2Y_45P5Q6Sr6OmBosI5y5nuEYy44F_B8wUsMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-animals.vue")
  },
  {
    name: "talking-animals___tr",
    path: "/tr/talking-animals",
    meta: talking_45animalsOef9AwboIL2Y_45P5Q6Sr6OmBosI5y5nuEYy44F_B8wUsMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-animals.vue")
  },
  {
    name: "talking-animals___zh",
    path: "/zh/talking-animals",
    meta: talking_45animalsOef9AwboIL2Y_45P5Q6Sr6OmBosI5y5nuEYy44F_B8wUsMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-animals.vue")
  },
  {
    name: "talking-cartoon___en",
    path: "/talking-cartoon",
    meta: talking_45cartoonkySIHcW9Czs1vYtgSLayUK9zSCst20Umuu9qRey8YNoMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-cartoon.vue")
  },
  {
    name: "talking-cartoon___ru",
    path: "/ru/talking-cartoon",
    meta: talking_45cartoonkySIHcW9Czs1vYtgSLayUK9zSCst20Umuu9qRey8YNoMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-cartoon.vue")
  },
  {
    name: "talking-cartoon___ja",
    path: "/ja/talking-cartoon",
    meta: talking_45cartoonkySIHcW9Czs1vYtgSLayUK9zSCst20Umuu9qRey8YNoMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-cartoon.vue")
  },
  {
    name: "talking-cartoon___id",
    path: "/id/talking-cartoon",
    meta: talking_45cartoonkySIHcW9Czs1vYtgSLayUK9zSCst20Umuu9qRey8YNoMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-cartoon.vue")
  },
  {
    name: "talking-cartoon___ar",
    path: "/ar/talking-cartoon",
    meta: talking_45cartoonkySIHcW9Czs1vYtgSLayUK9zSCst20Umuu9qRey8YNoMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-cartoon.vue")
  },
  {
    name: "talking-cartoon___cn",
    path: "/cn/talking-cartoon",
    meta: talking_45cartoonkySIHcW9Czs1vYtgSLayUK9zSCst20Umuu9qRey8YNoMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-cartoon.vue")
  },
  {
    name: "talking-cartoon___de",
    path: "/de/talking-cartoon",
    meta: talking_45cartoonkySIHcW9Czs1vYtgSLayUK9zSCst20Umuu9qRey8YNoMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-cartoon.vue")
  },
  {
    name: "talking-cartoon___es",
    path: "/es/talking-cartoon",
    meta: talking_45cartoonkySIHcW9Czs1vYtgSLayUK9zSCst20Umuu9qRey8YNoMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-cartoon.vue")
  },
  {
    name: "talking-cartoon___fr",
    path: "/fr/talking-cartoon",
    meta: talking_45cartoonkySIHcW9Czs1vYtgSLayUK9zSCst20Umuu9qRey8YNoMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-cartoon.vue")
  },
  {
    name: "talking-cartoon___it",
    path: "/it/talking-cartoon",
    meta: talking_45cartoonkySIHcW9Czs1vYtgSLayUK9zSCst20Umuu9qRey8YNoMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-cartoon.vue")
  },
  {
    name: "talking-cartoon___kr",
    path: "/kr/talking-cartoon",
    meta: talking_45cartoonkySIHcW9Czs1vYtgSLayUK9zSCst20Umuu9qRey8YNoMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-cartoon.vue")
  },
  {
    name: "talking-cartoon___nl",
    path: "/nl/talking-cartoon",
    meta: talking_45cartoonkySIHcW9Czs1vYtgSLayUK9zSCst20Umuu9qRey8YNoMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-cartoon.vue")
  },
  {
    name: "talking-cartoon___pt",
    path: "/pt/talking-cartoon",
    meta: talking_45cartoonkySIHcW9Czs1vYtgSLayUK9zSCst20Umuu9qRey8YNoMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-cartoon.vue")
  },
  {
    name: "talking-cartoon___tr",
    path: "/tr/talking-cartoon",
    meta: talking_45cartoonkySIHcW9Czs1vYtgSLayUK9zSCst20Umuu9qRey8YNoMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-cartoon.vue")
  },
  {
    name: "talking-cartoon___zh",
    path: "/zh/talking-cartoon",
    meta: talking_45cartoonkySIHcW9Czs1vYtgSLayUK9zSCst20Umuu9qRey8YNoMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-cartoon.vue")
  },
  {
    name: "ai-singing-photo___en",
    path: "/ai-singing-photo",
    meta: ai_45singing_45photordn8ugc69fF_V0HXjfOV2WW6KbYcIwE09QRhCYEyPR0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-singing-photo.vue")
  },
  {
    name: "ai-singing-photo___ru",
    path: "/ru/ai-singing-photo",
    meta: ai_45singing_45photordn8ugc69fF_V0HXjfOV2WW6KbYcIwE09QRhCYEyPR0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-singing-photo.vue")
  },
  {
    name: "ai-singing-photo___ja",
    path: "/ja/ai-singing-photo",
    meta: ai_45singing_45photordn8ugc69fF_V0HXjfOV2WW6KbYcIwE09QRhCYEyPR0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-singing-photo.vue")
  },
  {
    name: "ai-singing-photo___id",
    path: "/id/ai-singing-photo",
    meta: ai_45singing_45photordn8ugc69fF_V0HXjfOV2WW6KbYcIwE09QRhCYEyPR0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-singing-photo.vue")
  },
  {
    name: "ai-singing-photo___ar",
    path: "/ar/ai-singing-photo",
    meta: ai_45singing_45photordn8ugc69fF_V0HXjfOV2WW6KbYcIwE09QRhCYEyPR0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-singing-photo.vue")
  },
  {
    name: "ai-singing-photo___cn",
    path: "/cn/ai-singing-photo",
    meta: ai_45singing_45photordn8ugc69fF_V0HXjfOV2WW6KbYcIwE09QRhCYEyPR0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-singing-photo.vue")
  },
  {
    name: "ai-singing-photo___de",
    path: "/de/ai-singing-photo",
    meta: ai_45singing_45photordn8ugc69fF_V0HXjfOV2WW6KbYcIwE09QRhCYEyPR0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-singing-photo.vue")
  },
  {
    name: "ai-singing-photo___es",
    path: "/es/ai-singing-photo",
    meta: ai_45singing_45photordn8ugc69fF_V0HXjfOV2WW6KbYcIwE09QRhCYEyPR0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-singing-photo.vue")
  },
  {
    name: "ai-singing-photo___fr",
    path: "/fr/ai-singing-photo",
    meta: ai_45singing_45photordn8ugc69fF_V0HXjfOV2WW6KbYcIwE09QRhCYEyPR0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-singing-photo.vue")
  },
  {
    name: "ai-singing-photo___it",
    path: "/it/ai-singing-photo",
    meta: ai_45singing_45photordn8ugc69fF_V0HXjfOV2WW6KbYcIwE09QRhCYEyPR0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-singing-photo.vue")
  },
  {
    name: "ai-singing-photo___kr",
    path: "/kr/ai-singing-photo",
    meta: ai_45singing_45photordn8ugc69fF_V0HXjfOV2WW6KbYcIwE09QRhCYEyPR0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-singing-photo.vue")
  },
  {
    name: "ai-singing-photo___nl",
    path: "/nl/ai-singing-photo",
    meta: ai_45singing_45photordn8ugc69fF_V0HXjfOV2WW6KbYcIwE09QRhCYEyPR0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-singing-photo.vue")
  },
  {
    name: "ai-singing-photo___pt",
    path: "/pt/ai-singing-photo",
    meta: ai_45singing_45photordn8ugc69fF_V0HXjfOV2WW6KbYcIwE09QRhCYEyPR0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-singing-photo.vue")
  },
  {
    name: "ai-singing-photo___tr",
    path: "/tr/ai-singing-photo",
    meta: ai_45singing_45photordn8ugc69fF_V0HXjfOV2WW6KbYcIwE09QRhCYEyPR0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-singing-photo.vue")
  },
  {
    name: "ai-singing-photo___zh",
    path: "/zh/ai-singing-photo",
    meta: ai_45singing_45photordn8ugc69fF_V0HXjfOV2WW6KbYcIwE09QRhCYEyPR0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-singing-photo.vue")
  },
  {
    name: "talking-photo-ai___en",
    path: "/talking-photo-ai",
    meta: talking_45photo_45aiTn8dVHeUp9562xVWwm7BY8IcmU7_eicSOny3WIQ4ulMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-photo-ai.vue")
  },
  {
    name: "talking-photo-ai___ru",
    path: "/ru/talking-photo-ai",
    meta: talking_45photo_45aiTn8dVHeUp9562xVWwm7BY8IcmU7_eicSOny3WIQ4ulMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-photo-ai.vue")
  },
  {
    name: "talking-photo-ai___ja",
    path: "/ja/talking-photo-ai",
    meta: talking_45photo_45aiTn8dVHeUp9562xVWwm7BY8IcmU7_eicSOny3WIQ4ulMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-photo-ai.vue")
  },
  {
    name: "talking-photo-ai___id",
    path: "/id/talking-photo-ai",
    meta: talking_45photo_45aiTn8dVHeUp9562xVWwm7BY8IcmU7_eicSOny3WIQ4ulMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-photo-ai.vue")
  },
  {
    name: "talking-photo-ai___ar",
    path: "/ar/talking-photo-ai",
    meta: talking_45photo_45aiTn8dVHeUp9562xVWwm7BY8IcmU7_eicSOny3WIQ4ulMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-photo-ai.vue")
  },
  {
    name: "talking-photo-ai___cn",
    path: "/cn/talking-photo-ai",
    meta: talking_45photo_45aiTn8dVHeUp9562xVWwm7BY8IcmU7_eicSOny3WIQ4ulMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-photo-ai.vue")
  },
  {
    name: "talking-photo-ai___de",
    path: "/de/talking-photo-ai",
    meta: talking_45photo_45aiTn8dVHeUp9562xVWwm7BY8IcmU7_eicSOny3WIQ4ulMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-photo-ai.vue")
  },
  {
    name: "talking-photo-ai___es",
    path: "/es/talking-photo-ai",
    meta: talking_45photo_45aiTn8dVHeUp9562xVWwm7BY8IcmU7_eicSOny3WIQ4ulMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-photo-ai.vue")
  },
  {
    name: "talking-photo-ai___fr",
    path: "/fr/talking-photo-ai",
    meta: talking_45photo_45aiTn8dVHeUp9562xVWwm7BY8IcmU7_eicSOny3WIQ4ulMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-photo-ai.vue")
  },
  {
    name: "talking-photo-ai___it",
    path: "/it/talking-photo-ai",
    meta: talking_45photo_45aiTn8dVHeUp9562xVWwm7BY8IcmU7_eicSOny3WIQ4ulMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-photo-ai.vue")
  },
  {
    name: "talking-photo-ai___kr",
    path: "/kr/talking-photo-ai",
    meta: talking_45photo_45aiTn8dVHeUp9562xVWwm7BY8IcmU7_eicSOny3WIQ4ulMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-photo-ai.vue")
  },
  {
    name: "talking-photo-ai___nl",
    path: "/nl/talking-photo-ai",
    meta: talking_45photo_45aiTn8dVHeUp9562xVWwm7BY8IcmU7_eicSOny3WIQ4ulMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-photo-ai.vue")
  },
  {
    name: "talking-photo-ai___pt",
    path: "/pt/talking-photo-ai",
    meta: talking_45photo_45aiTn8dVHeUp9562xVWwm7BY8IcmU7_eicSOny3WIQ4ulMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-photo-ai.vue")
  },
  {
    name: "talking-photo-ai___tr",
    path: "/tr/talking-photo-ai",
    meta: talking_45photo_45aiTn8dVHeUp9562xVWwm7BY8IcmU7_eicSOny3WIQ4ulMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-photo-ai.vue")
  },
  {
    name: "talking-photo-ai___zh",
    path: "/zh/talking-photo-ai",
    meta: talking_45photo_45aiTn8dVHeUp9562xVWwm7BY8IcmU7_eicSOny3WIQ4ulMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-photo-ai.vue")
  },
  {
    name: "ai-image-to-video___en",
    path: "/ai-image-to-video",
    meta: ai_45image_45to_45videoynP4rycFYp54ttTsNvx7SvLvHf_fUL5LJs1daMZ_454NMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-image-to-video.vue")
  },
  {
    name: "ai-image-to-video___ru",
    path: "/ru/ai-image-to-video",
    meta: ai_45image_45to_45videoynP4rycFYp54ttTsNvx7SvLvHf_fUL5LJs1daMZ_454NMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-image-to-video.vue")
  },
  {
    name: "ai-image-to-video___ja",
    path: "/ja/ai-image-to-video",
    meta: ai_45image_45to_45videoynP4rycFYp54ttTsNvx7SvLvHf_fUL5LJs1daMZ_454NMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-image-to-video.vue")
  },
  {
    name: "ai-image-to-video___id",
    path: "/id/ai-image-to-video",
    meta: ai_45image_45to_45videoynP4rycFYp54ttTsNvx7SvLvHf_fUL5LJs1daMZ_454NMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-image-to-video.vue")
  },
  {
    name: "ai-image-to-video___ar",
    path: "/ar/ai-image-to-video",
    meta: ai_45image_45to_45videoynP4rycFYp54ttTsNvx7SvLvHf_fUL5LJs1daMZ_454NMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-image-to-video.vue")
  },
  {
    name: "ai-image-to-video___cn",
    path: "/cn/ai-image-to-video",
    meta: ai_45image_45to_45videoynP4rycFYp54ttTsNvx7SvLvHf_fUL5LJs1daMZ_454NMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-image-to-video.vue")
  },
  {
    name: "ai-image-to-video___de",
    path: "/de/ai-image-to-video",
    meta: ai_45image_45to_45videoynP4rycFYp54ttTsNvx7SvLvHf_fUL5LJs1daMZ_454NMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-image-to-video.vue")
  },
  {
    name: "ai-image-to-video___es",
    path: "/es/ai-image-to-video",
    meta: ai_45image_45to_45videoynP4rycFYp54ttTsNvx7SvLvHf_fUL5LJs1daMZ_454NMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-image-to-video.vue")
  },
  {
    name: "ai-image-to-video___fr",
    path: "/fr/ai-image-to-video",
    meta: ai_45image_45to_45videoynP4rycFYp54ttTsNvx7SvLvHf_fUL5LJs1daMZ_454NMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-image-to-video.vue")
  },
  {
    name: "ai-image-to-video___it",
    path: "/it/ai-image-to-video",
    meta: ai_45image_45to_45videoynP4rycFYp54ttTsNvx7SvLvHf_fUL5LJs1daMZ_454NMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-image-to-video.vue")
  },
  {
    name: "ai-image-to-video___kr",
    path: "/kr/ai-image-to-video",
    meta: ai_45image_45to_45videoynP4rycFYp54ttTsNvx7SvLvHf_fUL5LJs1daMZ_454NMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-image-to-video.vue")
  },
  {
    name: "ai-image-to-video___nl",
    path: "/nl/ai-image-to-video",
    meta: ai_45image_45to_45videoynP4rycFYp54ttTsNvx7SvLvHf_fUL5LJs1daMZ_454NMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-image-to-video.vue")
  },
  {
    name: "ai-image-to-video___pt",
    path: "/pt/ai-image-to-video",
    meta: ai_45image_45to_45videoynP4rycFYp54ttTsNvx7SvLvHf_fUL5LJs1daMZ_454NMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-image-to-video.vue")
  },
  {
    name: "ai-image-to-video___tr",
    path: "/tr/ai-image-to-video",
    meta: ai_45image_45to_45videoynP4rycFYp54ttTsNvx7SvLvHf_fUL5LJs1daMZ_454NMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-image-to-video.vue")
  },
  {
    name: "ai-image-to-video___zh",
    path: "/zh/ai-image-to-video",
    meta: ai_45image_45to_45videoynP4rycFYp54ttTsNvx7SvLvHf_fUL5LJs1daMZ_454NMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-image-to-video.vue")
  },
  {
    name: "ai-human-generator___en",
    path: "/ai-human-generator",
    meta: ai_45human_45generatorrIRFFMgIBomJH0G55h7h3J0znh9pQd9EZoJPDf53Z9IMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-human-generator.vue")
  },
  {
    name: "ai-human-generator___ru",
    path: "/ru/ai-human-generator",
    meta: ai_45human_45generatorrIRFFMgIBomJH0G55h7h3J0znh9pQd9EZoJPDf53Z9IMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-human-generator.vue")
  },
  {
    name: "ai-human-generator___ja",
    path: "/ja/ai-human-generator",
    meta: ai_45human_45generatorrIRFFMgIBomJH0G55h7h3J0znh9pQd9EZoJPDf53Z9IMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-human-generator.vue")
  },
  {
    name: "ai-human-generator___id",
    path: "/id/ai-human-generator",
    meta: ai_45human_45generatorrIRFFMgIBomJH0G55h7h3J0znh9pQd9EZoJPDf53Z9IMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-human-generator.vue")
  },
  {
    name: "ai-human-generator___ar",
    path: "/ar/ai-human-generator",
    meta: ai_45human_45generatorrIRFFMgIBomJH0G55h7h3J0znh9pQd9EZoJPDf53Z9IMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-human-generator.vue")
  },
  {
    name: "ai-human-generator___cn",
    path: "/cn/ai-human-generator",
    meta: ai_45human_45generatorrIRFFMgIBomJH0G55h7h3J0znh9pQd9EZoJPDf53Z9IMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-human-generator.vue")
  },
  {
    name: "ai-human-generator___de",
    path: "/de/ai-human-generator",
    meta: ai_45human_45generatorrIRFFMgIBomJH0G55h7h3J0znh9pQd9EZoJPDf53Z9IMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-human-generator.vue")
  },
  {
    name: "ai-human-generator___es",
    path: "/es/ai-human-generator",
    meta: ai_45human_45generatorrIRFFMgIBomJH0G55h7h3J0znh9pQd9EZoJPDf53Z9IMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-human-generator.vue")
  },
  {
    name: "ai-human-generator___fr",
    path: "/fr/ai-human-generator",
    meta: ai_45human_45generatorrIRFFMgIBomJH0G55h7h3J0znh9pQd9EZoJPDf53Z9IMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-human-generator.vue")
  },
  {
    name: "ai-human-generator___it",
    path: "/it/ai-human-generator",
    meta: ai_45human_45generatorrIRFFMgIBomJH0G55h7h3J0znh9pQd9EZoJPDf53Z9IMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-human-generator.vue")
  },
  {
    name: "ai-human-generator___kr",
    path: "/kr/ai-human-generator",
    meta: ai_45human_45generatorrIRFFMgIBomJH0G55h7h3J0znh9pQd9EZoJPDf53Z9IMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-human-generator.vue")
  },
  {
    name: "ai-human-generator___nl",
    path: "/nl/ai-human-generator",
    meta: ai_45human_45generatorrIRFFMgIBomJH0G55h7h3J0znh9pQd9EZoJPDf53Z9IMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-human-generator.vue")
  },
  {
    name: "ai-human-generator___pt",
    path: "/pt/ai-human-generator",
    meta: ai_45human_45generatorrIRFFMgIBomJH0G55h7h3J0znh9pQd9EZoJPDf53Z9IMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-human-generator.vue")
  },
  {
    name: "ai-human-generator___tr",
    path: "/tr/ai-human-generator",
    meta: ai_45human_45generatorrIRFFMgIBomJH0G55h7h3J0znh9pQd9EZoJPDf53Z9IMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-human-generator.vue")
  },
  {
    name: "ai-human-generator___zh",
    path: "/zh/ai-human-generator",
    meta: ai_45human_45generatorrIRFFMgIBomJH0G55h7h3J0znh9pQd9EZoJPDf53Z9IMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-human-generator.vue")
  },
  {
    name: "ai-image-generator___en",
    path: "/ai-image-generator",
    meta: ai_45image_45generatornSxcSdLld2uVC_4538mQup_t1y92ilxXJ2oFN_45Pug92e4Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-image-generator.vue")
  },
  {
    name: "ai-image-generator___ru",
    path: "/ru/ai-image-generator",
    meta: ai_45image_45generatornSxcSdLld2uVC_4538mQup_t1y92ilxXJ2oFN_45Pug92e4Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-image-generator.vue")
  },
  {
    name: "ai-image-generator___ja",
    path: "/ja/ai-image-generator",
    meta: ai_45image_45generatornSxcSdLld2uVC_4538mQup_t1y92ilxXJ2oFN_45Pug92e4Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-image-generator.vue")
  },
  {
    name: "ai-image-generator___id",
    path: "/id/ai-image-generator",
    meta: ai_45image_45generatornSxcSdLld2uVC_4538mQup_t1y92ilxXJ2oFN_45Pug92e4Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-image-generator.vue")
  },
  {
    name: "ai-image-generator___ar",
    path: "/ar/ai-image-generator",
    meta: ai_45image_45generatornSxcSdLld2uVC_4538mQup_t1y92ilxXJ2oFN_45Pug92e4Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-image-generator.vue")
  },
  {
    name: "ai-image-generator___cn",
    path: "/cn/ai-image-generator",
    meta: ai_45image_45generatornSxcSdLld2uVC_4538mQup_t1y92ilxXJ2oFN_45Pug92e4Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-image-generator.vue")
  },
  {
    name: "ai-image-generator___de",
    path: "/de/ai-image-generator",
    meta: ai_45image_45generatornSxcSdLld2uVC_4538mQup_t1y92ilxXJ2oFN_45Pug92e4Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-image-generator.vue")
  },
  {
    name: "ai-image-generator___es",
    path: "/es/ai-image-generator",
    meta: ai_45image_45generatornSxcSdLld2uVC_4538mQup_t1y92ilxXJ2oFN_45Pug92e4Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-image-generator.vue")
  },
  {
    name: "ai-image-generator___fr",
    path: "/fr/ai-image-generator",
    meta: ai_45image_45generatornSxcSdLld2uVC_4538mQup_t1y92ilxXJ2oFN_45Pug92e4Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-image-generator.vue")
  },
  {
    name: "ai-image-generator___it",
    path: "/it/ai-image-generator",
    meta: ai_45image_45generatornSxcSdLld2uVC_4538mQup_t1y92ilxXJ2oFN_45Pug92e4Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-image-generator.vue")
  },
  {
    name: "ai-image-generator___kr",
    path: "/kr/ai-image-generator",
    meta: ai_45image_45generatornSxcSdLld2uVC_4538mQup_t1y92ilxXJ2oFN_45Pug92e4Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-image-generator.vue")
  },
  {
    name: "ai-image-generator___nl",
    path: "/nl/ai-image-generator",
    meta: ai_45image_45generatornSxcSdLld2uVC_4538mQup_t1y92ilxXJ2oFN_45Pug92e4Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-image-generator.vue")
  },
  {
    name: "ai-image-generator___pt",
    path: "/pt/ai-image-generator",
    meta: ai_45image_45generatornSxcSdLld2uVC_4538mQup_t1y92ilxXJ2oFN_45Pug92e4Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-image-generator.vue")
  },
  {
    name: "ai-image-generator___tr",
    path: "/tr/ai-image-generator",
    meta: ai_45image_45generatornSxcSdLld2uVC_4538mQup_t1y92ilxXJ2oFN_45Pug92e4Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-image-generator.vue")
  },
  {
    name: "ai-image-generator___zh",
    path: "/zh/ai-image-generator",
    meta: ai_45image_45generatornSxcSdLld2uVC_4538mQup_t1y92ilxXJ2oFN_45Pug92e4Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-image-generator.vue")
  },
  {
    name: "ai-avatar-generator___en",
    path: "/ai-avatar-generator",
    meta: ai_45avatar_45generator_45qZNCqTmJXIA9lquYZKPf6cz_45NZ63S6_xFhKlxAgqJYMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-avatar-generator.vue")
  },
  {
    name: "ai-avatar-generator___ru",
    path: "/ru/ai-avatar-generator",
    meta: ai_45avatar_45generator_45qZNCqTmJXIA9lquYZKPf6cz_45NZ63S6_xFhKlxAgqJYMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-avatar-generator.vue")
  },
  {
    name: "ai-avatar-generator___ja",
    path: "/ja/ai-avatar-generator",
    meta: ai_45avatar_45generator_45qZNCqTmJXIA9lquYZKPf6cz_45NZ63S6_xFhKlxAgqJYMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-avatar-generator.vue")
  },
  {
    name: "ai-avatar-generator___id",
    path: "/id/ai-avatar-generator",
    meta: ai_45avatar_45generator_45qZNCqTmJXIA9lquYZKPf6cz_45NZ63S6_xFhKlxAgqJYMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-avatar-generator.vue")
  },
  {
    name: "ai-avatar-generator___ar",
    path: "/ar/ai-avatar-generator",
    meta: ai_45avatar_45generator_45qZNCqTmJXIA9lquYZKPf6cz_45NZ63S6_xFhKlxAgqJYMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-avatar-generator.vue")
  },
  {
    name: "ai-avatar-generator___cn",
    path: "/cn/ai-avatar-generator",
    meta: ai_45avatar_45generator_45qZNCqTmJXIA9lquYZKPf6cz_45NZ63S6_xFhKlxAgqJYMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-avatar-generator.vue")
  },
  {
    name: "ai-avatar-generator___de",
    path: "/de/ai-avatar-generator",
    meta: ai_45avatar_45generator_45qZNCqTmJXIA9lquYZKPf6cz_45NZ63S6_xFhKlxAgqJYMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-avatar-generator.vue")
  },
  {
    name: "ai-avatar-generator___es",
    path: "/es/ai-avatar-generator",
    meta: ai_45avatar_45generator_45qZNCqTmJXIA9lquYZKPf6cz_45NZ63S6_xFhKlxAgqJYMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-avatar-generator.vue")
  },
  {
    name: "ai-avatar-generator___fr",
    path: "/fr/ai-avatar-generator",
    meta: ai_45avatar_45generator_45qZNCqTmJXIA9lquYZKPf6cz_45NZ63S6_xFhKlxAgqJYMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-avatar-generator.vue")
  },
  {
    name: "ai-avatar-generator___it",
    path: "/it/ai-avatar-generator",
    meta: ai_45avatar_45generator_45qZNCqTmJXIA9lquYZKPf6cz_45NZ63S6_xFhKlxAgqJYMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-avatar-generator.vue")
  },
  {
    name: "ai-avatar-generator___kr",
    path: "/kr/ai-avatar-generator",
    meta: ai_45avatar_45generator_45qZNCqTmJXIA9lquYZKPf6cz_45NZ63S6_xFhKlxAgqJYMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-avatar-generator.vue")
  },
  {
    name: "ai-avatar-generator___nl",
    path: "/nl/ai-avatar-generator",
    meta: ai_45avatar_45generator_45qZNCqTmJXIA9lquYZKPf6cz_45NZ63S6_xFhKlxAgqJYMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-avatar-generator.vue")
  },
  {
    name: "ai-avatar-generator___pt",
    path: "/pt/ai-avatar-generator",
    meta: ai_45avatar_45generator_45qZNCqTmJXIA9lquYZKPf6cz_45NZ63S6_xFhKlxAgqJYMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-avatar-generator.vue")
  },
  {
    name: "ai-avatar-generator___tr",
    path: "/tr/ai-avatar-generator",
    meta: ai_45avatar_45generator_45qZNCqTmJXIA9lquYZKPf6cz_45NZ63S6_xFhKlxAgqJYMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-avatar-generator.vue")
  },
  {
    name: "ai-avatar-generator___zh",
    path: "/zh/ai-avatar-generator",
    meta: ai_45avatar_45generator_45qZNCqTmJXIA9lquYZKPf6cz_45NZ63S6_xFhKlxAgqJYMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-avatar-generator.vue")
  },
  {
    name: "ai-influencer-generator___en",
    path: "/ai-influencer-generator",
    meta: ai_45influencer_45generatoruX4k2qJ5RBBUi3qTqZq040hwnJwN9Fj0zFQKUPYs7B0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-influencer-generator.vue")
  },
  {
    name: "ai-influencer-generator___ru",
    path: "/ru/ai-influencer-generator",
    meta: ai_45influencer_45generatoruX4k2qJ5RBBUi3qTqZq040hwnJwN9Fj0zFQKUPYs7B0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-influencer-generator.vue")
  },
  {
    name: "ai-influencer-generator___ja",
    path: "/ja/ai-influencer-generator",
    meta: ai_45influencer_45generatoruX4k2qJ5RBBUi3qTqZq040hwnJwN9Fj0zFQKUPYs7B0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-influencer-generator.vue")
  },
  {
    name: "ai-influencer-generator___id",
    path: "/id/ai-influencer-generator",
    meta: ai_45influencer_45generatoruX4k2qJ5RBBUi3qTqZq040hwnJwN9Fj0zFQKUPYs7B0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-influencer-generator.vue")
  },
  {
    name: "ai-influencer-generator___ar",
    path: "/ar/ai-influencer-generator",
    meta: ai_45influencer_45generatoruX4k2qJ5RBBUi3qTqZq040hwnJwN9Fj0zFQKUPYs7B0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-influencer-generator.vue")
  },
  {
    name: "ai-influencer-generator___cn",
    path: "/cn/ai-influencer-generator",
    meta: ai_45influencer_45generatoruX4k2qJ5RBBUi3qTqZq040hwnJwN9Fj0zFQKUPYs7B0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-influencer-generator.vue")
  },
  {
    name: "ai-influencer-generator___de",
    path: "/de/ai-influencer-generator",
    meta: ai_45influencer_45generatoruX4k2qJ5RBBUi3qTqZq040hwnJwN9Fj0zFQKUPYs7B0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-influencer-generator.vue")
  },
  {
    name: "ai-influencer-generator___es",
    path: "/es/ai-influencer-generator",
    meta: ai_45influencer_45generatoruX4k2qJ5RBBUi3qTqZq040hwnJwN9Fj0zFQKUPYs7B0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-influencer-generator.vue")
  },
  {
    name: "ai-influencer-generator___fr",
    path: "/fr/ai-influencer-generator",
    meta: ai_45influencer_45generatoruX4k2qJ5RBBUi3qTqZq040hwnJwN9Fj0zFQKUPYs7B0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-influencer-generator.vue")
  },
  {
    name: "ai-influencer-generator___it",
    path: "/it/ai-influencer-generator",
    meta: ai_45influencer_45generatoruX4k2qJ5RBBUi3qTqZq040hwnJwN9Fj0zFQKUPYs7B0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-influencer-generator.vue")
  },
  {
    name: "ai-influencer-generator___kr",
    path: "/kr/ai-influencer-generator",
    meta: ai_45influencer_45generatoruX4k2qJ5RBBUi3qTqZq040hwnJwN9Fj0zFQKUPYs7B0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-influencer-generator.vue")
  },
  {
    name: "ai-influencer-generator___nl",
    path: "/nl/ai-influencer-generator",
    meta: ai_45influencer_45generatoruX4k2qJ5RBBUi3qTqZq040hwnJwN9Fj0zFQKUPYs7B0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-influencer-generator.vue")
  },
  {
    name: "ai-influencer-generator___pt",
    path: "/pt/ai-influencer-generator",
    meta: ai_45influencer_45generatoruX4k2qJ5RBBUi3qTqZq040hwnJwN9Fj0zFQKUPYs7B0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-influencer-generator.vue")
  },
  {
    name: "ai-influencer-generator___tr",
    path: "/tr/ai-influencer-generator",
    meta: ai_45influencer_45generatoruX4k2qJ5RBBUi3qTqZq040hwnJwN9Fj0zFQKUPYs7B0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-influencer-generator.vue")
  },
  {
    name: "ai-influencer-generator___zh",
    path: "/zh/ai-influencer-generator",
    meta: ai_45influencer_45generatoruX4k2qJ5RBBUi3qTqZq040hwnJwN9Fj0zFQKUPYs7B0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-influencer-generator.vue")
  },
  {
    name: "ai-animate-face-lip-sync___en",
    path: "/ai-animate-face-lip-sync",
    meta: ai_45animate_45face_45lip_45syncGB9_45_xo1q3ReJfK_LZSY7EcSotC2hHgCClL4McnlmkIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-animate-face-lip-sync.vue")
  },
  {
    name: "ai-animate-face-lip-sync___ru",
    path: "/ru/ai-animate-face-lip-sync",
    meta: ai_45animate_45face_45lip_45syncGB9_45_xo1q3ReJfK_LZSY7EcSotC2hHgCClL4McnlmkIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-animate-face-lip-sync.vue")
  },
  {
    name: "ai-animate-face-lip-sync___ja",
    path: "/ja/ai-animate-face-lip-sync",
    meta: ai_45animate_45face_45lip_45syncGB9_45_xo1q3ReJfK_LZSY7EcSotC2hHgCClL4McnlmkIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-animate-face-lip-sync.vue")
  },
  {
    name: "ai-animate-face-lip-sync___id",
    path: "/id/ai-animate-face-lip-sync",
    meta: ai_45animate_45face_45lip_45syncGB9_45_xo1q3ReJfK_LZSY7EcSotC2hHgCClL4McnlmkIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-animate-face-lip-sync.vue")
  },
  {
    name: "ai-animate-face-lip-sync___ar",
    path: "/ar/ai-animate-face-lip-sync",
    meta: ai_45animate_45face_45lip_45syncGB9_45_xo1q3ReJfK_LZSY7EcSotC2hHgCClL4McnlmkIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-animate-face-lip-sync.vue")
  },
  {
    name: "ai-animate-face-lip-sync___cn",
    path: "/cn/ai-animate-face-lip-sync",
    meta: ai_45animate_45face_45lip_45syncGB9_45_xo1q3ReJfK_LZSY7EcSotC2hHgCClL4McnlmkIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-animate-face-lip-sync.vue")
  },
  {
    name: "ai-animate-face-lip-sync___de",
    path: "/de/ai-animate-face-lip-sync",
    meta: ai_45animate_45face_45lip_45syncGB9_45_xo1q3ReJfK_LZSY7EcSotC2hHgCClL4McnlmkIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-animate-face-lip-sync.vue")
  },
  {
    name: "ai-animate-face-lip-sync___es",
    path: "/es/ai-animate-face-lip-sync",
    meta: ai_45animate_45face_45lip_45syncGB9_45_xo1q3ReJfK_LZSY7EcSotC2hHgCClL4McnlmkIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-animate-face-lip-sync.vue")
  },
  {
    name: "ai-animate-face-lip-sync___fr",
    path: "/fr/ai-animate-face-lip-sync",
    meta: ai_45animate_45face_45lip_45syncGB9_45_xo1q3ReJfK_LZSY7EcSotC2hHgCClL4McnlmkIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-animate-face-lip-sync.vue")
  },
  {
    name: "ai-animate-face-lip-sync___it",
    path: "/it/ai-animate-face-lip-sync",
    meta: ai_45animate_45face_45lip_45syncGB9_45_xo1q3ReJfK_LZSY7EcSotC2hHgCClL4McnlmkIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-animate-face-lip-sync.vue")
  },
  {
    name: "ai-animate-face-lip-sync___kr",
    path: "/kr/ai-animate-face-lip-sync",
    meta: ai_45animate_45face_45lip_45syncGB9_45_xo1q3ReJfK_LZSY7EcSotC2hHgCClL4McnlmkIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-animate-face-lip-sync.vue")
  },
  {
    name: "ai-animate-face-lip-sync___nl",
    path: "/nl/ai-animate-face-lip-sync",
    meta: ai_45animate_45face_45lip_45syncGB9_45_xo1q3ReJfK_LZSY7EcSotC2hHgCClL4McnlmkIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-animate-face-lip-sync.vue")
  },
  {
    name: "ai-animate-face-lip-sync___pt",
    path: "/pt/ai-animate-face-lip-sync",
    meta: ai_45animate_45face_45lip_45syncGB9_45_xo1q3ReJfK_LZSY7EcSotC2hHgCClL4McnlmkIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-animate-face-lip-sync.vue")
  },
  {
    name: "ai-animate-face-lip-sync___tr",
    path: "/tr/ai-animate-face-lip-sync",
    meta: ai_45animate_45face_45lip_45syncGB9_45_xo1q3ReJfK_LZSY7EcSotC2hHgCClL4McnlmkIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-animate-face-lip-sync.vue")
  },
  {
    name: "ai-animate-face-lip-sync___zh",
    path: "/zh/ai-animate-face-lip-sync",
    meta: ai_45animate_45face_45lip_45syncGB9_45_xo1q3ReJfK_LZSY7EcSotC2hHgCClL4McnlmkIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-animate-face-lip-sync.vue")
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ru/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ru/ru/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ja/ru/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/id/ru/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ar/ru/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/cn/ru/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/de/ru/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/es/ru/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/fr/ru/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/it/ru/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/kr/ru/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/nl/ru/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/pt/ru/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/tr/ru/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/zh/ru/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ru/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ru/ru/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ja/ru/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/id/ru/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ar/ru/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/cn/ru/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/de/ru/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/es/ru/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/fr/ru/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/it/ru/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/kr/ru/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/nl/ru/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/pt/ru/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/tr/ru/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/zh/ru/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ja/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ru/ja/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ja/ja/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/id/ja/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ar/ja/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/cn/ja/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/de/ja/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/es/ja/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/fr/ja/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/it/ja/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/kr/ja/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/nl/ja/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/pt/ja/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/tr/ja/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/zh/ja/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ja/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ru/ja/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ja/ja/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/id/ja/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ar/ja/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/cn/ja/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/de/ja/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/es/ja/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/fr/ja/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/it/ja/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/kr/ja/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/nl/ja/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/pt/ja/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/tr/ja/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/zh/ja/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/id/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ru/id/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ja/id/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/id/id/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ar/id/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/cn/id/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/de/id/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/es/id/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/fr/id/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/it/id/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/kr/id/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/nl/id/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/pt/id/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/tr/id/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/zh/id/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/id/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ru/id/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ja/id/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/id/id/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ar/id/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/cn/id/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/de/id/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/es/id/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/fr/id/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/it/id/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/kr/id/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/nl/id/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/pt/id/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/tr/id/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/zh/id/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ar/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ru/ar/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ja/ar/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/id/ar/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ar/ar/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/cn/ar/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/de/ar/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/es/ar/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/fr/ar/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/it/ar/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/kr/ar/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/nl/ar/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/pt/ar/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/tr/ar/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/zh/ar/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ar/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ru/ar/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ja/ar/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/id/ar/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ar/ar/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/cn/ar/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/de/ar/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/es/ar/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/fr/ar/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/it/ar/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/kr/ar/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/nl/ar/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/pt/ar/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/tr/ar/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/zh/ar/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/cn/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ru/cn/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ja/cn/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/id/cn/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ar/cn/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/cn/cn/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/de/cn/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/es/cn/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/fr/cn/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/it/cn/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/kr/cn/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/nl/cn/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/pt/cn/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/tr/cn/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/zh/cn/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/cn/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ru/cn/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ja/cn/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/id/cn/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ar/cn/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/cn/cn/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/de/cn/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/es/cn/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/fr/cn/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/it/cn/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/kr/cn/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/nl/cn/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/pt/cn/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/tr/cn/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/zh/cn/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/de/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ru/de/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ja/de/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/id/de/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ar/de/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/cn/de/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/de/de/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/es/de/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/fr/de/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/it/de/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/kr/de/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/nl/de/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/pt/de/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/tr/de/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/zh/de/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/de/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ru/de/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ja/de/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/id/de/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ar/de/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/cn/de/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/de/de/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/es/de/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/fr/de/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/it/de/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/kr/de/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/nl/de/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/pt/de/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/tr/de/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/zh/de/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/es/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ru/es/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ja/es/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/id/es/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ar/es/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/cn/es/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/de/es/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/es/es/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/fr/es/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/it/es/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/kr/es/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/nl/es/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/pt/es/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/tr/es/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/zh/es/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/es/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ru/es/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ja/es/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/id/es/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ar/es/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/cn/es/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/de/es/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/es/es/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/fr/es/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/it/es/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/kr/es/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/nl/es/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/pt/es/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/tr/es/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/zh/es/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/fr/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ru/fr/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ja/fr/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/id/fr/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ar/fr/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/cn/fr/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/de/fr/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/es/fr/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/fr/fr/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/it/fr/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/kr/fr/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/nl/fr/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/pt/fr/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/tr/fr/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/zh/fr/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/fr/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ru/fr/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ja/fr/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/id/fr/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ar/fr/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/cn/fr/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/de/fr/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/es/fr/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/fr/fr/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/it/fr/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/kr/fr/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/nl/fr/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/pt/fr/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/tr/fr/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/zh/fr/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/it/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ru/it/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ja/it/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/id/it/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ar/it/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/cn/it/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/de/it/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/es/it/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/fr/it/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/it/it/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/kr/it/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/nl/it/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/pt/it/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/tr/it/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/zh/it/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/it/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ru/it/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ja/it/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/id/it/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ar/it/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/cn/it/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/de/it/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/es/it/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/fr/it/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/it/it/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/kr/it/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/nl/it/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/pt/it/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/tr/it/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/zh/it/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/kr/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ru/kr/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ja/kr/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/id/kr/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ar/kr/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/cn/kr/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/de/kr/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/es/kr/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/fr/kr/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/it/kr/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/kr/kr/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/nl/kr/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/pt/kr/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/tr/kr/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/zh/kr/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/kr/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ru/kr/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ja/kr/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/id/kr/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ar/kr/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/cn/kr/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/de/kr/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/es/kr/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/fr/kr/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/it/kr/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/kr/kr/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/nl/kr/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/pt/kr/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/tr/kr/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/zh/kr/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/nl/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ru/nl/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ja/nl/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/id/nl/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ar/nl/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/cn/nl/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/de/nl/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/es/nl/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/fr/nl/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/it/nl/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/kr/nl/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/nl/nl/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/pt/nl/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/tr/nl/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/zh/nl/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/nl/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ru/nl/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ja/nl/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/id/nl/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ar/nl/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/cn/nl/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/de/nl/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/es/nl/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/fr/nl/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/it/nl/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/kr/nl/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/nl/nl/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/pt/nl/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/tr/nl/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/zh/nl/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/pt/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ru/pt/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ja/pt/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/id/pt/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ar/pt/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/cn/pt/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/de/pt/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/es/pt/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/fr/pt/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/it/pt/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/kr/pt/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/nl/pt/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/pt/pt/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/tr/pt/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/zh/pt/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/pt/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ru/pt/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ja/pt/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/id/pt/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ar/pt/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/cn/pt/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/de/pt/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/es/pt/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/fr/pt/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/it/pt/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/kr/pt/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/nl/pt/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/pt/pt/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/tr/pt/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/zh/pt/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/tr/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ru/tr/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ja/tr/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/id/tr/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ar/tr/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/cn/tr/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/de/tr/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/es/tr/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/fr/tr/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/it/tr/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/kr/tr/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/nl/tr/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/pt/tr/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/tr/tr/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/zh/tr/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/tr/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ru/tr/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ja/tr/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/id/tr/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ar/tr/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/cn/tr/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/de/tr/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/es/tr/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/fr/tr/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/it/tr/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/kr/tr/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/nl/tr/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/pt/tr/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/tr/tr/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/zh/tr/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/zh/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ru/zh/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ja/zh/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/id/zh/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ar/zh/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/cn/zh/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/de/zh/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/es/zh/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/fr/zh/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/it/zh/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/kr/zh/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/nl/zh/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/pt/zh/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/tr/zh/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/zh/zh/blog",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/zh/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ru/zh/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ja/zh/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/id/zh/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ar/zh/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/cn/zh/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/de/zh/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/es/zh/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/fr/zh/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/it/zh/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/kr/zh/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/nl/zh/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/pt/zh/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/tr/zh/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/zh/zh/blog/:pathMatch(.*)",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ru/sitemap.xml",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ja/sitemap.xml",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/id/sitemap.xml",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/ar/sitemap.xml",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/cn/sitemap.xml",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/de/sitemap.xml",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/es/sitemap.xml",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/fr/sitemap.xml",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/it/sitemap.xml",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/kr/sitemap.xml",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/nl/sitemap.xml",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/pt/sitemap.xml",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/tr/sitemap.xml",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  },
  {
    name: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZIMeta?.name,
    path: "/zh/sitemap.xml",
    component: component_45stubsYcCLavZkW7vyYBih_45EVOXZfEz_0F6bK6TTCLHBhMZI
  }
]